<template>
  <v-card>
    <v-col sm="12">
      <v-btn
        v-if="processAction != 'view'"
        small
        class="mr-2 ma-3"
        color="success"
        @click="saveProcess()"
      >{{ $t('PROCESSES.BUILD_PROCESS.BTNS.SAVE') }}</v-btn>
      <v-btn
        v-if="processAction != 'view'"
        small
        class="mr-2 ma-3"
        color="warning"
        @click="checkLocks()"
      >{{ $t('PROCESSES.BUILD_PROCESS.BTNS.SAVE_DEPLOY') }}</v-btn>
      <v-btn
        small
        class="mr-2 ma-3"
        color="secondary"
        @click="closeProcess()"
      >{{ $t('PROCESSES.BUILD_PROCESS.BTNS.CLOSE') }}</v-btn>
      <v-btn
        id="download-svg"
        small
        class="mr-2 ma-3 float-right"
        color="success"
        @click="downloadSvgImage()"
      >{{ $t('PROCESSES.BUILD_PROCESS.BTNS.DOWNLOAD') }}</v-btn>
      <v-btn
        id="download-diagram"
        small
        class="mr-2 ma-3 float-right"
        color="warning"
        @click="downloadDiagram()"
      >{{ $t('PROCESSES.BUILD_PROCESS.BTNS.EXPORT') }}</v-btn>
      <v-btn
        v-if="processAction != 'view'"
        small
        class="mr-2 ma-3 float-right"
        color="error"
        @click="saveExternalProcess()"
        :disabled="allHqConns.length == 0"
      >{{ $t('PROCESSES.BUILD_PROCESS.BTNS.PROMOTE') }}</v-btn>
    </v-col>

    <v-row>
      <v-col sm="12">
        <div id="canvas" class="canvas"></div>
      </v-col>
    </v-row>

    <v-btn
      v-if="processAction != 'view'"
      small
      class="mr-2 ma-3 processBtn"
      color="success"
      @click="configureProcess()"
    >{{ $t('PROCESSES.BUILD_PROCESS.BTNS.CONFIGURE') }}</v-btn>
    <v-btn
      v-if="processAction != 'view'"
      small
      class="mr-2 ma-3 modeBtn"
      color="warning"
      @click="setUpdateProps()"
    >{{ modeStatus }}</v-btn>

    <!-- New Properties Panel -->
    <v-dialog
        transition="dialog-bottom-transition"
        max-width="1000"
        v-model="propsDialog"
        :retain-focus="false"
        persistent
      >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ $t('PROCESSES.BUILD_PROCESS.PROPERTIES.TITLE') }}</v-toolbar>
          <v-tabs v-model="tab">
            <v-tab>
              {{ $t('PROCESSES.BUILD_PROCESS.PROPERTIES.TABS.GENERAL') }}
            </v-tab>
            <v-tab v-if="isCallActivity || isSignalThrowEvent" @click="setFilter('variable')">
              {{ $t('PROCESSES.BUILD_PROCESS.PROPERTIES.TABS.VARIABLES') }}
            </v-tab>
            <v-tab v-if="!isCollab && !isLane" @click="setFilter('listener')">
              {{ $t('PROCESSES.BUILD_PROCESS.PROPERTIES.TABS.LISTENERS') }}
            </v-tab>
            <v-tab v-if="hasLooping">
              {{ $t('PROCESSES.BUILD_PROCESS.PROPERTIES.TABS.MULTI') }}
            </v-tab>
          </v-tabs>
          <v-card-text>
            <v-form v-model="isFormValid" ref="propsForm">
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <v-row class="mt-2" v-if="isEvent">
                    <v-col cols="12" sm="12">
                      <v-select
                        v-model="eventType"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.EVENT_TYPE')"
                        :items="filteredEventItems"
                        item-text="label"
                        item-value="value"
                        @change="changeEventType"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row class="mt-2" v-if="isTask">
                    <v-col cols="12" sm="12">
                      <v-select
                        v-model="taskType"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.TASK_TYPE')"
                        :items="taskTypes"
                        item-text="label"
                        item-value="value"
                        @change="changeTaskType"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row class="mt-2" v-if="isTask && !isCallActivity && !isServiceTask && !isScriptTask">
                    <v-col cols="12" sm="6">
                      <v-switch
                        v-model="sendEmails"
                        color="success"
                        class="pt-3 pl-2"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.SEND_EMAILS')"
                        @change="changeSendEmails"
                      ></v-switch>
                    </v-col>
                    <v-col cols="12" sm="6" v-if="sendEmails">
                      <v-autocomplete 
                        v-model="emailTemplate"
                        :items="allEmailTemplates" 
                        item-text="NAME"
                        item-value="TEMP_KEY"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.EMAIL_TEMPLATE')"
                        @change="changeEmailTemplate"
                        :rules="[rules.required]"
                        return-object
                      >{{ emailTemplate }}</v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row class="mt-2" v-if="isTask && !isCallActivity && !isServiceTask && !isScriptTask && sendEmails">
                    <v-col cols="12" sm="12">
                      <v-text-field
                        v-model="emailSubject"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.EMAIL_SUBJECT')"
                        maxlength=255
                        @change="changeEmailSubject"
                        :rules="[rules.required]"
                      >{{ emailSubject }}</v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="mt-2" v-if="isGateway">
                    <v-col cols="12" sm="12">
                      <v-select
                        v-model="gatewayType"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.GATEWAY_TYPE')"
                        :items="gatewayTypes"
                        item-text="label"
                        item-value="value"
                        @change="changeTaskType"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row class="mt-2" v-if="isFlow && hasCondition">
                    <v-col cols="12" sm="12">
                      <v-select
                        v-model="conditionType"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.CONDITION_TYPE')"
                        :items="conditionTypes"
                        item-text="label"
                        item-value="value"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row v-if="isProcess && collabActive">
                    <v-col cols="12" sm="12" md="6">
                      <v-text-field
                        v-model="participantId"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.PARTICIPANT_ID')"
                        maxlength=24
                        @change="event => changeField(event, 'participantId')"
                        :rules="[rules.required]"
                        disabled
                      >{{ participantId }}</v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-text-field
                        v-model="participantName"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.PARTICIPANT_NAME')"
                        @change="event => changeField(event, 'participantName')"
                      >{{ participantName }}</v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="6">
                      <v-text-field
                        v-model="elementId"
                        :label="isCollab && isProcess ? $t('PROCESSES.FIELDS.PROCESS_ID') : $t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.ID')"
                        maxlength=24
                        @change="event => changeField(event, 'id')"
                        :rules="[rules.required]"
                        disabled
                      >{{ elementId }}</v-text-field>
                      <v-btn
                        v-if="isProcess"
                        small
                        color="warning"
                        @click="requestNewProcId()"
                      >{{ $t('PROCESSES.BUILD_PROCESS.BTNS.NEW_PROC_ID') }}</v-btn>
                    </v-col>
                    <v-col v-if="!isCollab" cols="12" sm="12" md="6">
                      <v-text-field
                        v-model="elementName"
                        :label="isCollab && isProcess ? $t('PROCESSES.FIELDS.PROCESS_NAME') : $t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.NAME')"
                        @change="event => changeField(event, 'name')"
                      >{{ elementName }}</v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="isTimerStartEvent">
                    <v-col cols="12" sm="12" md="6">
                      <v-select
                        v-model="timerDefType"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.TIMER_DEF_TYPE')"
                        :items="timerDefTypes"
                        item-text="label"
                        item-value="value"
                        @change="event => changeField(event, 'timerDefinitionType')"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-text-field
                      class="mt-6"
                        v-model="timerDefinition"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.TIMER_DEF')"
                        @change="event => changeField(event, 'timerDefinition')"
                        :rules="[rules.required]"
                      >{{ timerDefinition }}</v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="isConditionalStartEvent || isCondThrowEvent || isCondCatchEvent || isCondBoundaryEvent || isCondNonBoundaryEvent">
                    <v-col cols="12" sm="12" md="6">
                      <v-text-field
                        v-model="startVarName"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.VAR_NAME')"
                        @change="event => changeField(event, 'startVarName')"
                      >{{ startVarName }}</v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-text-field
                        v-model="startCondition"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.EXPRESSION')"
                        @change="event => changeField(event, 'startCondition')"
                        :rules="[rules.required]"
                      >{{ startCondition }}</v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="isCondThrowEvent || isCondCatchEvent || isCondBoundaryEvent || isCondNonBoundaryEvent">
                    <v-col cols="12" sm="12">
                      <v-text-field
                        v-model="varEvents"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.VAR_EVENTS')"
                        @change="event => changeField(event, 'varEvents')"
                      >{{ varEvents }}</v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="isSignalStartEvent">
                    <v-col cols="12" sm="9">
                      <v-combobox 
                        v-model="startSignalName"
                        :items="availableSignals" 
                        item-text="name"
                        item-value="name"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.SIGNAL_NAME')"
                        @change="event => changeField(event, 'startSignalName')"
                        :rules="[rules.required]"
                      >{{ startSignalName }}</v-combobox>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-btn
                        block
                        color="error"
                        class="mt-8"
                        @click="deleteSignal()"
                      >{{ $t('PROCESSES.BUILD_PROCESS.PROPERTIES.BTNS.DELETE_SIGNAL') }}</v-btn>
                    </v-col>
                  </v-row>
                  <v-row v-if="(!isCallActivity && !isServiceTask && !isScriptTask) && (isTask || isStartEvent)">
                    <v-col cols="12" sm="12">
                      <v-combobox
                        v-model="formKey"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.FORM')"
                        :items="processForms"
                        :item-text="getFormText"
                        item-value="FORM_KEY"
                        @change="event => changeField(event, 'formKey')"
                      ></v-combobox>
                    </v-col>
                  </v-row>
                  <v-row v-if="isProcess">
                    <v-col cols="12" sm="12" md="6">                    
                      <v-combobox
                        v-model="candidateStarterUsers"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.STARTER_USERS')"
                        :items="allUsers"
                        item-text="fullName"
                        item-value="id"
                        multiple
                        @change="event => changeField(event, 'candidateStarterUsers')"
                      ></v-combobox>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-combobox
                        v-model="candidateStarterGroups"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.STARTER_GROUPS')"
                        :items="allGroups"
                        item-text="name"
                        item-value="id"
                        multiple
                        @change="event => changeField(event, 'candidateStarterGroups')"
                      ></v-combobox>
                    </v-col>
                  </v-row>
                  <v-row v-if="isProcess">
                    <v-col cols="12" sm="12" md="6">
                      <v-text-field
                        v-model="historyTimeToLive"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.HISTORY_TTL')"
                        @change="event => changeField(event, 'historyTimeToLive')"
                      >{{ historyTimeToLive }}</v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-checkbox
                        v-model="isStartable"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.STARTABLE')"
                        :value="isStartable"
                        hide-details
                        @change="event => changeField(event, 'isStartableInTasklist')"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <!-- <v-row v-if="isProcess">
                    <v-col cols="12" sm="12" md="6">
                      <v-checkbox
                        v-model="isExecutable"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.EXECUTABLE')"
                        :value="isExecutable"
                        hide-details
                        @change="event => changeField(event, 'isExecutable')"
                      ></v-checkbox>
                    </v-col>
                  </v-row> -->
                  <v-row v-if="isTask && !isCallActivity && !isServiceTask && !isScriptTask">
                    <v-col cols="12" sm="12" md="4">
                      <v-combobox
                        v-model="assignee"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.ASSIGNEE')"
                        :items="allUsers"
                        item-text="fullName"
                        item-value="id"
                        clearable
                        @change="event => changeField(event, 'assignee')"
                      ></v-combobox>
                    </v-col>
                    <v-col cols="12" sm="12" md="4">
                      <v-combobox
                        v-model="candidateUsers"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.USERS')"
                        :items="allUsers"
                        item-text="fullName"
                        item-value="id"
                        multiple
                        clearable
                        @change="event => changeField(event, 'candidateUsers')"
                      ></v-combobox>
                    </v-col>
                    <v-col cols="12" sm="12" md="4">
                      <v-combobox
                        v-model="candidateGroups"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.GROUPS')"
                        :items="allGroups"
                        item-text="name"
                        item-value="id"
                        multiple
                        clearable
                        @change="event => changeField(event, 'candidateGroups')"
                      ></v-combobox>
                    </v-col>
                  </v-row>
                  <v-row v-if="isTask && !isCallActivity && !isServiceTask && !isScriptTask">
                    <v-col cols="12" sm="12" md="6">
                      <v-text-field
                        v-model="dueDate"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.DUE_DATE')"
                        @change="event => changeField(event, 'dueDate')"
                      >{{ dueDate }}</v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-text-field
                        v-model="followUpDate"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.FOLLOW_UP_DATE')"
                        @change="event => changeField(event, 'followUpDate')"
                      >{{ followUpDate }}</v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="isCallActivity">
                    <v-col cols="12" sm="12" md="6">
                      <v-select
                        v-model="calledElement"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.TARGET')"
                        :items="calledElementItems"
                        item-text="text"
                        item-value="val"
                        @change="event => changeField(event, 'callableElementRef')"
                        :rules="[rules.required]"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-select
                        v-model="tenantId"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.TENANT_ID')"
                        :items="allTenants"
                        item-text="name"
                        item-value="id"
                        @change="event => changeField(event, 'tenantId')"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row v-if="isCallActivity && calledElement == 'apiController'">
                    <v-col cols="12" sm="12" md="6">
                      <v-select
                        v-model="targetApi"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.API')"
                        :items="targetApis"
                        item-text="text"
                        item-value="val"
                        @change="event => changeField(event, 'targetApi')"
                        :rules="[rules.required]"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-select
                        v-model="apiCallType"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.CALL_TYPE')"
                        :items="apiCallTypes"
                        item-text="text"
                        item-value="val"
                        @change="event => changeField(event, 'targetApiType')"
                        :rules="[rules.required]"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row v-if="isCallActivity && calledElement == 'apiController' && grantType == 'client_credentials'">
                    <v-col cols="12" sm="12" md="4">
                      <v-checkbox
                        v-model="includeGrantType"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.INCLUDE_GRANT')"
                        :value="includeGrantType"
                        hide-details
                        @change="event => changeField(event, 'includeGrantType')"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="12" md="4">
                      <v-checkbox
                        v-model="includeClientId"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.INCLUDE_ID')"
                        :value="includeClientId"
                        hide-details
                        @change="event => changeField(event, 'includeClientId')"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="12" md="4">
                      <v-checkbox
                        v-model="includeClientSecret"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.INCLUDE_SECRET')"
                        :value="includeClientSecret"
                        hide-details
                        @change="event => changeField(event, 'includeClientSecret')"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row v-if="isCallActivity && calledElement == 'apiController'">
                    <v-col cols="12" sm="12" md="6">
                      <v-btn
                        block
                        color="primary"
                        @click="apiParameters()"
                      >{{ $t('PROCESSES.BUILD_PROCESS.PROPERTIES.BTNS.PARAMS') }}</v-btn>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-btn
                        block
                        color="primary"
                        @click="apiHeaders()"
                      >{{ $t('PROCESSES.BUILD_PROCESS.PROPERTIES.BTNS.HEADERS') }}</v-btn>
                    </v-col>
                  </v-row>
                  <v-row v-if="isCallActivity && calledElement == 'apiController'">
                    <v-col cols="12" sm="12">
                      <v-text-field
                        v-model="apiUrlQuery"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.URL_QUERY')"
                        @change="event => changeField(event, 'apiUrlQuery')"
                      >{{ apiUrlQuery }}</v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="isCallActivity && calledElement == 'apiController' && (apiCallType == 'post' || apiCallType == 'put')">
                    <v-col cols="12" sm="12">
                      <v-textarea
                        v-model="apiPostData"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.JSON_DATA')"
                        @change="event => changeField(event, 'apiPostData')"
                      >{{ apiPostData }}</v-textarea>
                    </v-col>
                  </v-row>
                  <v-row v-if="isCallActivity">
                    <v-col cols="12" sm="12">
                      <v-checkbox
                        v-model="useCaseId"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.USE_PARENT_ID')"
                        :value="useCaseId"
                        hide-details
                        @change="event => changeField(event, 'callableBusinessKey')"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row v-if="hasCondition">
                    <v-col cols="12" sm="12">
                      <v-text-field
                        v-model="condition"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.EXPRESSION')"
                        @change="event => changeField(event, 'condition')"
                        :rules="ignoreRules ? [] : [rules.required]"
                      >{{ condition }}</v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="isServiceTask">
                    <v-col cols="12" sm="12">
                      <v-text-field
                        v-model="javaClass"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.JAVA_CLASS')"
                        @change="event => changeField(event, 'javaClass')"
                        :rules="[rules.required]"
                      >{{ javaClass }}</v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="isScriptTask">
                    <v-col cols="12" sm="12">
                      <v-text-field
                        v-model="scriptResultVariable"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.RESULT_VAR')"
                        @change="event => changeField(event, 'scriptResultVariable')"
                      >{{ scriptResultVariable }}</v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="isScriptTask">
                    <v-col cols="12" sm="12">
                      <v-btn
                        small
                        color="success"
                        width="100%"
                        @click="openJsEditor()"
                      >{{ $t('PROCESSES.BUILD_PROCESS.PROPERTIES.BTNS.EDITOR') }}</v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12">
                      <v-textarea
                        v-model="elementNotes"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.NOTES')"
                        @change="event => changeField(event, 'documentation')"
                      >{{ elementNotes }}</v-textarea>
                    </v-col>
                  </v-row>
                </v-tab-item>

                <v-tab-item v-if="isCallActivity || isSignalThrowEvent">
                  <v-row>
                    <v-col cols="12" sm="12">
                      <v-data-table :headers="variableHeaders" :items="filteredItems" item-key="id">
                        <template slot="top">
                          <v-toolbar
                            flat
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              small
                              class="mr-2"
                              color="success"
                              @click="addVariableDialog = true"
                            ><v-icon medium>mdi-plus</v-icon></v-btn>
                          </v-toolbar>
                        </template>
                        <template slot="item.actions" slot-scope="row">
                          <v-btn
                            small
                            class="mr-2 float-right"
                            color="error"
                            @click="deleteExtension(row.item.id)"
                          ><v-icon medium>mdi-trash-can-outline</v-icon></v-btn>
                          <v-btn
                            small
                            class="mr-2 float-right"
                            color="warning"
                            @click="editVariable(row.item.id)"
                          ><v-icon medium>mdi-pencil-outline</v-icon></v-btn>
                        </template>
                      </v-data-table> 
                    </v-col>
                  </v-row>
                </v-tab-item>

                <v-tab-item>
                  <v-row>
                    <v-col cols="12" sm="12">
                      <v-data-table :headers="listenerHeaders" :items="filteredItems" item-key="id">
                        <template slot="top">
                          <v-toolbar
                            flat
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              small
                              class="mr-2"
                              color="success"
                              @click="addListenerDialog = true"
                            ><v-icon medium>mdi-plus</v-icon></v-btn>
                          </v-toolbar>
                        </template>
                        <template slot="item.actions" slot-scope="row">
                          <v-btn
                            v-if="row.item.listTaskType != 'sendEmails' && row.item.listTaskType != 'sendEmailsScript'"
                            small
                            class="mr-2 float-right"
                            color="error"
                            @click="deleteExtension(row.item.id)"
                          ><v-icon medium>mdi-trash-can-outline</v-icon></v-btn>
                          <v-btn
                            v-if="row.item.listTaskType != 'sendEmails' && row.item.listTaskType != 'sendEmailsScript'"
                            small
                            class="mr-2 float-right"
                            color="warning"
                            @click="editListener(row.item.id)"
                          ><v-icon medium>mdi-pencil-outline</v-icon></v-btn>
                        </template>
                      </v-data-table> 
                    </v-col>
                  </v-row>
                </v-tab-item>

                <v-tab-item v-if="hasLooping">
                  <v-row>
                    <v-col cols="12" sm="12" md="6">
                      <v-text-field
                        v-model="multiInstanceCount"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.MULTI_COUNT')"
                        @change="event => changeField(event, 'multiInstanceCount')"
                        :rules="[rules.required]"
                      >{{ multiInstanceCount }}</v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-text-field
                        v-model="completionCondition"
                        :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.COMPLETE_COND')"
                        @change="event => changeField(event, 'completionCondition')"
                      >{{ completionCondition }}</v-text-field>
                    </v-col>
                  </v-row>
                </v-tab-item>
              </v-tabs-items>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="closeProps()"
            >{{ $t('GENERAL.BTNS.CLOSE') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
        transition="dialog-bottom-transition"
        max-width="400"
        v-model="saveDialog"
        :retain-focus="false"
        persistent
      >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ saveTitle }}</v-toolbar>
          <v-card-text>
            <div :class="processExists ? 'pt-5 red--text' : 'pt-5'">{{ saveText }}</div>
            <v-form v-model="isFormValid">
              <v-row>
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="deployName"
                    :label="$t('PROCESSES.FIELDS.DEPLOY_NAME')"
                    :rules="[rules.required]"
                    disabled
                  >{{ deployName }}</v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-select
                    v-if="deploy"
                    v-model="selectedTenant"
                    :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.TENANT')"
                    :items="allTenants"
                    item-text="name"
                    item-value="id"
                    :rules="[rules.required]"
                  ></v-select>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="saveDialog = false"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              v-if="!deploy"
              text
              @click="confirmSave()"
            >{{ $t('GENERAL.BTNS.SAVE') }}</v-btn>
            <v-btn
              v-if="deploy"
              text
              :disabled="!isFormValid"
              @click="confirmDeploy()"
            >{{ $t('PROCESSES.BUILD_PROCESS.BTNS.DEPLOY') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
        transition="dialog-bottom-transition"
        max-width="400"
        v-model="saveExternalDialog"
        :retain-focus="false"
        persistent
      >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ saveExternalTitle }}</v-toolbar>
          <v-card-text>
            <div :class="processExists ? 'pt-5 red--text' : 'pt-5'">{{ saveExternalText }}</div>
            <div :class="processExists ? 'pt-5 red--text' : 'pt-5'" v-html="saveExternalText2"></div>
            <v-form v-model="isFormValid" ref="promoteForm">
              <v-row>
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="deployName"
                    :label="$t('PROCESSES.FIELDS.DEPLOY_NAME')"
                    :rules="[rules.required]"
                    disabled
                  >{{ deployName }}</v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-select
                    v-model="selectedExternalEngine"
                    :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.REMOTE_ENGINE')"
                    :items="allHqConns"
                    item-text="ENGINE_NAME"
                    item-value="URL"
                    :rules="[rules.required]"
                  ></v-select>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="cancelExternalSave()"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              :disabled="!isFormValid"
              @click="confirmExternalSave()"
            >{{ $t('GENERAL.BTNS.SAVE') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
        transition="dialog-bottom-transition"
        max-width="400"
        v-model="showLockedDialog"
        :retain-focus="false"
        persistent
      >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ lockedTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ lockedText }}</div>
            <div class="pt-5"><span v-html="lockedFormText"></span></div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="showLockedDialog = false"
            >{{ $t('GENERAL.BTNS.CLOSE') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
        transition="dialog-bottom-transition"
        max-width="400"
        v-model="newProcIdDialog"
        :retain-focus="false"
        persistent
      >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ $t('PROCESSES.BUILD_PROCESS.PROPERTIES.NEW_PROC_ID_TITLE') }}</v-toolbar>
          <v-card-text>
            <div class="pt-5 red--text">{{ $t('PROCESSES.BUILD_PROCESS.PROPERTIES.NEW_PROC_ID_DESC') }}</div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="newProcIdDialog = false"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="confirmNewProcId()"
            >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      transition="dialog-bottom-transition"
      max-width="600"
      v-model="saveCloseDialog"
      :retain-focus="false"
      persistent
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ $t('PROCESSES.SAVE_PROCESS.TITLE_SAVE') }}</v-toolbar>
          <v-card-text>
            <div class="pt-5">{{ $t('PROCESSES.SAVE_PROCESS.SAVE_CLOSE') }}</div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="confirmClose('no')"
            >{{ $t('PROCESSES.BUILD_PROCESS.PROPERTIES.BTNS.CLOSE_NO_SAVE') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="confirmClose('save')"
            >{{ $t('PROCESSES.BUILD_PROCESS.PROPERTIES.BTNS.SAVE_CHANGES') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <!-- Variable Dialogs -->
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="800"
      v-model="addVariableDialog"
      :retain-focus="false"
      persistent
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ $t('PROCESSES.BUILD_PROCESS.PROPERTIES.ADD_VAR_TITLE') }}</v-toolbar>
          <v-card-text>
            <v-form v-model="isFormValid" ref="addVariableForm">
              <v-row class="mt-2">
                <v-col cols="12" sm="12" md="6">
                  <v-select
                    v-model="variableInOut"
                    :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.VAR_IN_OUT')"
                    :items="variableInOuts"
                    item-text="text"
                    item-value="val"
                    :item-disabled="disableVariableItem"
                    :rules="[rules.required]"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-select
                    v-model="variableType"
                    :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.VAR_TYPE')"
                    :items="variableTypes"
                    item-text="text"
                    item-value="val"
                    :rules="[rules.required]"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row v-if="variableType == 'source'">
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="variableSource"
                    :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.VAR_SOURCE')"
                    :rules="[rules.required]"
                  >{{ variableSource }}</v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="variableTarget"
                    :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.VAR_TARGET')"
                    :rules="[rules.required]"
                  >{{ variableTarget }}</v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="cancelVariable('new')"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              :disabled="!isFormValid"
              @click="saveVariable('new')"
            >{{ $t('GENERAL.BTNS.SAVE') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      transition="dialog-bottom-transition"
      max-width="800"
      v-model="editVariableDialog"
      :retain-focus="false"
      persistent
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ $t('PROCESSES.BUILD_PROCESS.PROPERTIES.EDIT_VAR_TITLE') }}</v-toolbar>
          <v-card-text>
            <v-form v-model="isFormValid" ref="editVariableForm">
              <v-row class="mt-2">
                <v-col cols="12" sm="12" md="6">
                  <v-select
                    v-model="variableInOut"
                    :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.VAR_IN_OUT')"
                    :items="variableInOuts"
                    item-text="text"
                    item-value="val"
                    :item-disabled="disableVariableItem"
                    disabled
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-select
                    v-model="variableType"
                    :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.VAR_TYPE')"
                    :items="variableTypes"
                    item-text="text"
                    item-value="val"
                    :rules="[rules.required]"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row v-if="variableType != 'all'">
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="variableSource"
                    :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.VAR_SOURCE')"
                    :rules="[rules.required]"
                  >{{ variableSource }}</v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="variableTarget"
                    :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.VAR_TARGET')"
                    :rules="[rules.required]"
                  >{{ variableTarget }}</v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="cancelVariable('edit')"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              :disabled="!isFormValid"
              @click="saveVariable('edit')"
            >{{ $t('GENERAL.BTNS.SAVE') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <!-- Listerner Dialogs -->
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="800"
      v-model="addListenerDialog"
      :retain-focus="false"
      persistent
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ $t('PROCESSES.BUILD_PROCESS.PROPERTIES.ADD_LIST_TITLE') }}</v-toolbar>
          <v-card-text>
            <v-form v-model="isFormValid" ref="addListenerForm">
              <v-row class="mt-2">
                <v-col cols="12" sm="12" md="6">
                  <v-select
                    v-model="listenerType"
                    :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.LIST_TYPE')"
                    :items="listenerTypes"
                    item-text="text"
                    item-value="val"
                    :item-disabled="disableListenerItem"
                    :rules="[rules.required]"
                  ></v-select>
                </v-col>
                <v-col v-if="listenerType == 'execution'" cols="12" sm="12" md="6">
                  <v-select
                    v-model="executionEventType"
                    :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.EVENT_TYPE')"
                    :items="executionEventTypes"
                    item-text="text"
                    item-value="val"
                    :rules="[rules.required]"
                  ></v-select>
                </v-col>
                <v-col v-if="listenerType == 'task'" cols="12" sm="12" md="6">
                  <v-select
                    v-model="taskEventType"
                    :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.EVENT_TYPE')"
                    :items="taskEventTypes"
                    item-text="text"
                    item-value="val"
                    :rules="[rules.required]"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row v-if="listenerType == 'task'">
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="listenerId"
                    :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.LIST_ID')"
                  >{{ listenerId }}</v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-btn
                    small
                    color="success"
                    width="100%"
                    @click="openJsEditor()"
                  >{{ $t('PROCESSES.BUILD_PROCESS.PROPERTIES.BTNS.EDITOR') }}</v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="cancelListener('new')"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              :disabled="!isFormValid"
              @click="saveListener('new')"
            >{{ $t('GENERAL.BTNS.SAVE') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      transition="dialog-bottom-transition"
      max-width="800"
      v-model="editListenerDialog"
      :retain-focus="false"
      persistent
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ $t('PROCESSES.BUILD_PROCESS.PROPERTIES.EDIT_LIST_TITLE') }}</v-toolbar>
          <v-card-text>
            <v-form v-model="isFormValid" ref="editListenerForm">
              <v-row class="mt-2">
                <v-col cols="12" sm="12" md="6">
                  <v-select
                    v-model="listenerType"
                    :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.LIST_TYPE')"
                    :items="listenerTypes"
                    item-text="text"
                    item-value="val"
                    :item-disabled="disableListenerItem"
                    disabled
                  ></v-select>
                </v-col>
                <v-col v-if="listenerType == 'execution'" cols="12" sm="12" md="6">
                  <v-select
                    v-model="executionEventType"
                    :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.EVENT_TYPE')"
                    :items="executionEventTypes"
                    item-text="text"
                    item-value="val"
                    :rules="[rules.required]"
                  ></v-select>
                </v-col>
                <v-col v-if="listenerType == 'task'" cols="12" sm="12" md="6">
                  <v-select
                    v-model="taskEventType"
                    :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.EVENT_TYPE')"
                    :items="taskEventTypes"
                    item-text="text"
                    item-value="val"
                    :rules="[rules.required]"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row v-if="listenerType == 'task'">
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="listenerId"
                    :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.LIST_ID')"
                  >{{ listenerId }}</v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-btn
                    small
                    color="success"
                    width="100%"
                    @click="openJsEditor()"
                  >{{ $t('PROCESSES.BUILD_PROCESS.PROPERTIES.BTNS.EDITOR') }}</v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="cancelListener('edit')"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              :disabled="!isFormValid"
              @click="saveListener('edit')"
            >{{ $t('GENERAL.BTNS.SAVE') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <!-- Parameter Dialogs -->
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="700"
      v-model="apiParamDialog"
      :retain-focus="false"
      persistent
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
            class="mb-3"
          >{{ $t('PROCESSES.BUILD_PROCESS.PROPERTIES.API_PARAMS_TITLE') }}</v-toolbar>
          <v-card-text>
            <v-form ref="addParam">
              <v-row>
                <v-col cols="12" sm="12">
                  <v-data-table :headers="apiParamHeaders" :items="apiParamItems" item-key="id">
                    <template slot="top">
                      <v-toolbar
                        color="#2c3a47"
                        dark
                      >{{ $t('PROCESSES.BUILD_PROCESS.PROPERTIES.API_PARAMS_TITLE') }}
                        <v-spacer></v-spacer>
                        <v-btn
                          small
                          class="mr-2"
                          color="success"
                          @click="addParamRow()"
                        ><v-icon medium>mdi-plus</v-icon></v-btn>
                      </v-toolbar>
                    </template>
                    <template slot="item.actions" slot-scope="row">
                      <v-btn
                        small
                        class="mr-2 float-right"
                        color="error"
                        @click="deleteParamRow(row.item.id)"
                      ><v-icon medium>mdi-trash-can-outline</v-icon></v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="cancelParams()"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="saveParams()"
            >{{ $t('GENERAL.BTNS.SAVE') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      transition="dialog-bottom-transition"
      max-width="500"
      v-model="addParamRowDialog"
      :retain-focus="false"
      persistent
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ $t('PROCESSES.BUILD_PROCESS.PROPERTIES.ADD_API_PARAM_TITLE') }}</v-toolbar>
          <v-card-text>
            <v-form v-model="isFormValid" ref="addParamRow">
              <v-row>
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="apiParamKey"
                    :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.PARAM_KEY')"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="apiParamValue"
                    :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.PARAM_VAL')"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-select
                    v-model="apiParamType"
                    :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.PARAM_TYPE')"
                    :items="apiParamTypes"
                    item-text="text"
                    item-value="val"
                    :rules="[rules.required]"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-checkbox
                    v-model="apiFormData"
                    :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.IS_DATA_FIELD')"
                    :value="apiFormData"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="cancelAddParamRow()"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              :disabled="!isFormValid"
              @click="confirmAddParamRow()"
            >{{ $t('GENERAL.BTNS.ADD') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <!-- Header Dialogs -->
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="700"
      v-model="apiHeadersDialog"
      :retain-focus="false"
      persistent
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
            class="mb-3"
          >{{ $t('PROCESSES.BUILD_PROCESS.PROPERTIES.API_HEADERS_TITLE') }}</v-toolbar>
          <v-card-text>
            <v-form ref="addHeader">
              <v-row>
                <v-col cols="12" sm="12">
                  <v-data-table :headers="apiHeaderHeaders" :items="apiHeaderItems" item-key="id">
                    <template slot="top">
                      <v-toolbar
                        color="#2c3a47"
                        dark
                      >{{ $t('PROCESSES.BUILD_PROCESS.PROPERTIES.API_HEADERS_TITLE') }}
                        <v-spacer></v-spacer>
                        <v-btn
                          small
                          class="mr-2"
                          color="success"
                          @click="addHeaderRow()"
                        ><v-icon medium>mdi-plus</v-icon></v-btn>
                      </v-toolbar>
                    </template>
                    <template slot="item.actions" slot-scope="row">
                      <v-btn
                        small
                        class="mr-2 float-right"
                        color="error"
                        @click="deleteHeaderRow(row.item.id)"
                      ><v-icon medium>mdi-trash-can-outline</v-icon></v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="cancelHeaders()"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="saveHeaders()"
            >{{ $t('GENERAL.BTNS.SAVE') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      transition="dialog-bottom-transition"
      max-width="500"
      v-model="addHeaderRowDialog"
      :retain-focus="false"
      persistent
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ $t('PROCESSES.BUILD_PROCESS.PROPERTIES.ADD_API_HEADER_TITLE') }}</v-toolbar>
          <v-card-text>
            <v-form v-model="isFormValid" ref="addHeaderRow">
              <v-row>
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="apiHeaderKey"
                    :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.HEADER_KEY')"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="apiHeaderValue"
                    :label="$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.HEADER_VAL')"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="cancelAddHeaderRow()"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              :disabled="!isFormValid"
              @click="confirmAddHeaderRow()"
            >{{ $t('GENERAL.BTNS.ADD') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <!-- Editor Dialog -->
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="95%"
      v-model="jsEditorDialog"
      :retain-focus="false"
      persistent
      content-class="js-dialog"
    >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ $t('PROCESSES.BUILD_PROCESS.PROPERTIES.EDITOR_TITLE') }}</v-toolbar>
          <v-card-text>
            <div class="editor-wrapper">
              <code-mirror class="mt-2" v-model="jsScript" :extensions="extensions" />
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="closeJsEditor()"
            >{{ $t('GENERAL.BTNS.CLOSE') }}</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-snackbar
      v-model="snack"
      :timeout="10000"
      :color="snackColor"
    >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          v-bind="attrs"
          text
          @click="snack = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>

  </v-card>
</template>

<script>
  import $ from 'jquery';
  import Modeler from '../assets/process-builder/lib/Modeler';
  import propertiesPanelModule from '../assets/properties-panel';
  // providing Harlequin executable properties, too
  import propertiesProviderModule from '../assets/properties-panel/lib/provider/harlequin';
  import harlequinModdleDescriptor from '../assets/harlequin-bpmn-moddle/resources/harlequin';
  import bpmnXML from '../assets/bpmn/newDiagram.bpmn';
  import { mapGetters } from 'vuex';
  import CodeMirror from 'vue-codemirror6';
  import { basicSetup } from '@codemirror/basic-setup';
  import { EditorView, keymap } from '@codemirror/view';
  import { indentWithTab } from '@codemirror/commands';
  import { oneDark } from '@codemirror/theme-one-dark';
  import { javascript } from '@codemirror/lang-javascript';
  import { syntaxTree } from '@codemirror/language';
  import { autocompletion } from '@codemirror/autocomplete';

  const completePropertyAfter = ["PropertyName", ".", "?."]
  const dontCompleteIn = ["TemplateString", "LineComment", "BlockComment",
                        "VariableDefinition", "PropertyDefinition"]

  export default {
    name: 'buildprocess',
    computed: {
      ...mapGetters(['processId', 'deploymentName', 'processAction', 'processXml', 'processVersion', 'processKey', 'savedProcessXml', 'deploymentSuccess', 'allUsers', 'allGroups', 'processSelections', 'allProcessXml', 'importXml', 'allTenants', 'lockedForms', 'allExternalProcessXml', 'allExternalTenants', 'allHqConns', 'externalProcessVersion', 'processForms', 'allApis', 'allEmailTemplates']),
      filteredItems() {
        return this.extensionItems.filter(item => !this.filterBy || (item.type === this.filterBy) && (item.listTaskType != 'sendEmails' && item.listTaskType != 'sendEmailsScript'))
      },
      filteredEventItems() {
        return this.eventTypes.filter(item => !this.filterEventBy || (item.style === this.filterEventBy))
      },
    },
    components: {
        CodeMirror
    },
    data: function() {
      return {
        processIdSet: false,
        newProcName: '',
        oldProcName: '',
        nameChange: false,
        newProcIdDialog: false,
        tab: null,
        isFormValid: false,
        rules: {
          required: value => !!value || 'Required'
        },
        showPropsPanel: true,
        showHideText: 'Hide Properties Panel',
        modeler: null,
        deployName: null,
        deploy: false,
        saveDialog: false,
        saveTitle: '',
        saveText: '',
        selectedTenant: '',
        saveExternalDialog: false,
        saveExternalTitle: '',
        saveExternalText: '',
        saveExternalText2: '',
        selectedExternalEngine: '',
        remoteExists: [],
        processExists: false,
        targetNode: '',
        dialogType: '',
        selections: {},
        groupSelectDialog: false,
        groupSelectTitle: '',
        groupSelectText: '',
        selectedGroups: '',
        snack: false,
        snackColor: '',
        snackText: '',
        theProcessName: '',
        theVersion: '',
        theProcessKey: '',
        showLockedDialog: false,
        lockedTitle: '',
        lockedText: '',
        lockedFormText: '',
        locksDetected: false,
        isLocked: 1,
        lockedBy: '',
        saveCloseDialog: false,
        saveThenClose: false,
        updateProps: false,
        modeStatus: this.$t('PROCESSES.BUILD_PROCESS.BTNS.MODE_BUILD'),
        propsDialog: false,
        participantId: '',
        participantName: '',
        currentParticipantId: '',
        elementId: '',
        currentProcessId: '',
        elementName: '',
        elementNotes: '',
        selectedElements: [],
        element: null,
        isEvent: false,
        isStartEvent: false,
        isTimerStartEvent: false,
        isTimerThrowEvent: false,
        isTimerCatchEvent: false,
        isTimerBoundaryEvent: false,
        isTimerNonBoundaryEvent: false,
        isConditionalStartEvent: false,
        isCondThrowEvent: false,
        isCondCatchEvent: false,
        isCondBoundaryEvent: false,
        isCondNonBoundaryEvent: false,
        isSignalStartEvent: false,
        isSignalThrowEvent: false,
        isSignalCatchEvent: false,
        isSignalBoundaryEvent: false,
        isSignalNonBoundaryEvent: false,
        isEndEvent: false,
        isTask: false,
        sendEmails: false,
        emailTemplate: '',
        emailSubject: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.EMAIL_SUBJECT_DEFAULT'),
        isCallActivity: false,
        isServiceTask: false,
        isScriptTask: false,
        hasLooping: false,
        multiInstanceCount: '',
        completionCondition: '',
        isFlow: false,
        isProcess: false,
        isCollab: false,
        isLane: false,
        isGateway: false,
        collabActive: false,
        hasCondition: false,
        ignoreRules: false,
        startVarName: '',
        startCondition: '',
        varEvents: '',
        availableSignals: [],
        eventTypes: [
          { label: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.EVENT_TYPES.START'), style: 'start', value: 'bpmn:StartEvent' },
          { label: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.EVENT_TYPES.TIMER_START'), style: 'start', value: 'bpmn:TimerEventDefinition' },
          { label: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.EVENT_TYPES.COND_START'), style: 'start', value: 'bpmn:ConditionalEventDefinition' },
          { label: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.EVENT_TYPES.SIGNAL_START'), style: 'start', value: 'bpmn:SignalEventDefinition' },
          { label: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.EVENT_TYPES.TIMER_INTER_CATCH'), style: 'inter', type: 'bpmn:TimerEventDefinition', value: 'interTimerCatch' },
          { label: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.EVENT_TYPES.COND_INTER_CATCH'), style: 'inter', type: 'bpmn:ConditionalEventDefinition', value: 'interCondCatch' },
          { label: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.EVENT_TYPES.SIGNAL_INTER_CATCH'), style: 'inter', type: 'bpmn:SignalEventDefinition', value: 'interSignalCatch' },
          { label: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.EVENT_TYPES.SIGNAL_INTER_THROW'), style: 'inter', type: 'bpmn:SignalEventDefinition', value: 'interSignalThrow' },
          { label: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.EVENT_TYPES.TIMER_BOUNDARY_INT'), style: 'boundary', type: 'bpmn:TimerEventDefinition', value: 'boundaryTimer' },
          { label: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.EVENT_TYPES.COND_BOUNDARY_INT'), style: 'boundary', type: 'bpmn:ConditionalEventDefinition', value: 'boundaryCond' },
          { label: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.EVENT_TYPES.SIGNAL_BOUNDARY_INT'), style: 'boundary', type: 'bpmn:SignalEventDefinition', value: 'boundarySignal' },
          { label: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.EVENT_TYPES.TIMER_BOUNDARY_NON_INT'), style: 'boundary', type: 'bpmn:TimerEventDefinition', value: 'boundaryTimerNon' },
          { label: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.EVENT_TYPES.COND_BOUNDARY_NON_INT'), style: 'boundary', type: 'bpmn:ConditionalEventDefinition', value: 'boundaryCondNon' },
          { label: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.EVENT_TYPES.SIGNAL_BOUNDARY_NON_INT'), style: 'boundary', type: 'bpmn:SignalEventDefinition', value: 'boundarySignalNon' },
          { label: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.EVENT_TYPES.END'), style: 'end', value: 'bpmn:EndEvent' },
          { label: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.EVENT_TYPES.TERMINATE'), style: 'end', value: 'bpmn:TerminateEventDefinition' }
        ],
        eventType: '',
        taskTypes: [
          { label: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.TASK_TYPES.USER'), value: 'bpmn:UserTask' },
          { label: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.TASK_TYPES.SUBPROCESS'), value: 'bpmn:CallActivity' },
          { label: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.TASK_TYPES.SCRIPT'), value: 'bpmn:ScriptTask' },
          { label: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.TASK_TYPES.SERVICE'), value: 'bpmn:ServiceTask' }
        ],
        taskType: '',
        gatewayTypes: [
          { label: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.GATEWAY_TYPES.EXCLUSIVE'), value: 'bpmn:ExclusiveGateway' },
          { label: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.GATEWAY_TYPES.INCLUSIVE'), value: 'bpmn:InclusiveGateway' },
          { label: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.GATEWAY_TYPES.PARALLEL'), value: 'bpmn:ParallelGateway' }
        ],
        gatewayType: '',
        conditionTypes: [
          { label: '', value: '' },
          { label: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.EXPRESSION'), value: 'expression' },
        ],
        conditionType: 'expression',
        condition: '',
        timerDefTypes: [
          { label: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.TIMER_DEF_TYPES.DATE'), value: 'date' },
          { label: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.TIMER_DEF_TYPES.DURATION'), value: 'duration' },
          { label: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.TIMER_DEF_TYPES.CYCLE'), value: 'cycle' }
        ],
        timerDefType: '',
        timerDefinition: '',
        startSignalId: '',
        startSignalName: '',
        filterEventBy: null,
        formKey: '',
        assignee: '',
        candidateStarterUsers: '',
        candidateStarterGroups: '',
        candidateUsers: '',
        candidateGroups: '',
        historyTimeToLive: '',
        isExecutable: true,
        isStartable: true,
        dueDate: '',
        followUpDate: '',
        javaClass: '',
        addVariableDialog: false,
        editVariableDialog: false,
        variableHeaders: [
          { text: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.VAR_IN_OUT'), align: 'start', value: 'variableInOut', sortable: false },
          { text: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.VAR_TYPE'), value: 'variableType', sortable: false },
          { text: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.VAR_SOURCE'), value: 'variableSource', sortable: false },
          { text: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.VAR_TARGET'), value: 'variableTarget', sortable: false },
          { text: '', value: 'actions', sortable: false }
        ],
        variableInOuts: [
          { text: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.VAR_IN'), val: 'in' },
          { text: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.VAR_OUT'), val: 'out' }
        ],
        variableInOut: '',
        variableTypes: [
          { text: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.VAR_ALL'), val: 'all' },
          { text: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.VAR_SOURCE'), val: 'source' }
        ],
        variableType: '',
        variableSource: '',
        variableTarget: '',
        addListenerDialog: false,
        editListenerDialog: false,
        extensionItem: null,
        filterBy: null,
        listenerHeaders: [
          { text: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.LIST_TYPE'), align: 'start', value: 'listenerType', sortable: false },
          { text: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.EVENT_TYPE'), value: 'listenerEventType', sortable: false },
          { text: '', value: 'actions', sortable: false }
        ],
        extensionItems: [],
        listenerTypes: [
          { text: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.EXECUTION'), val: 'execution' },
          { text: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.TASK'), val: 'task' }
        ],
        listenerType: '',
        executionEventTypes:[
          { text: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.START'), val: 'start' },
          { text: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.END'), val: 'end' }
        ],
        executionEventType: '',
        taskEventTypes: [
          { text: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.CREATE'), val: 'create' },
          { text: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.ASSIGNMENT'), val: 'assignment' },
          { text: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.COMPLETE'), val: 'complete' },
          { text: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.DELETE'), val: 'delete' },
          { text: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.UPDATE'), val: 'update' }
        ],
        taskEventType: '',
        listenerEventType: '',
        listenerId: '',
        listenerScript: '// Type your JavaScript below...\n',
        calledElementItems: [
          { text: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.CONTROLLERS.API'), val: 'apiController' },
          { text: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.CONTROLLERS.EMAIL'), val: 'emailController' },
          { text: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.CONTROLLERS.DOC'), val: 'documentController' },
          { text: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.CONTROLLERS.SQL'), val: 'sqlController' },
          { text: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.CONTROLLERS.USER'), val: 'userController' },
          { text: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.CONTROLLERS.LDAP'), val: 'ldapController' }
        ],
        calledElement: '',
        tenantId: '',
        targetApis: [],
        targetApi: '',
        grantType: '',
        apiCallTypes: [
          { text: 'GET', val: 'get' },
          { text: 'POST', val: 'post' },
          { text: 'PUT', val: 'put' },
          { text: 'DELETE', val: 'delete' }
        ],
        apiCallType: '',
        includeGrantType: false,
        includeClientId: false,
        includeClientSecret: false,
        apiUrlQuery: '',
        apiPostData: '{}',
        apiParamHeaders: [
          { text: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.PARAM_KEY'), align: 'start', value: 'apiParamKey', sortable: false },
          { text: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.PARAM_VAL'), value: 'apiParamValue', sortable: false },
          { text: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.PARAM_TYPE'), value: 'apiParamType', sortable: false },
          { text: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.DATA_FIELD'), value: 'apiFormData', sortable: false },
          { text: '', value: 'actions', sortable: false }
        ],
        apiParamTypes: [
          { text: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.STRING'), val: 'str' },
          { text: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.INTEGER'), val: 'int' },
          { text: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.BOOLEAN'), val: 'bool' }
        ],
        apiParamItems: [],
        apiParamKey: '',
        apiParamValue: '',
        apiParamType: '',
        apiFormData: false,
        apiParamDialog: false,
        addParamRowDialog: false,
        apiHeaderHeaders: [
          { text: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.HEADER_KEY'), align: 'start', value: 'apiHeaderKey', sortable: false },
          { text: this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.HEADER_VAL'), value: 'apiHeaderValue', sortable: false },
          { text: '', value: 'actions', sortable: false }
        ],
        apiHeaderItems: [],
        apiHeaderKey: '',
        apiHeaderValue: '',
        apiHeadersDialog: false,
        addHeaderRowDialog: false,
        useCaseId: false,
        scriptResultVariable: '',
        taskScript: '',
        editorState: null,
        editorView: null,
        editorChange: false,
        extensions: [
          basicSetup,
          oneDark,
          keymap.of([indentWithTab]),
          javascript(),
          autocompletion({override: [this.completeFromGlobalScope]}),
          EditorView.updateListener.of((v) => {
            this.editorState = v.state;
            this.editorView = v.view;

            if(v.docChanged) {
              this.editorChange = true;
            }
          })
        ],
        defaultScript: '// Type your JavaScript below...\n',
        jsEditorDialog: false,
        jsScript: '',
        collabEl: null,
        processEl: null
      }
    },
    async created() {
      this.unsubscribe = this.$store.subscribe((mutation) => {

        if(mutation.type === 'DEPLOYMENT_SUCCESS') {
          if(this.deploymentSuccess) {
            this.confirmSave();
          }else {
            this.snackFail();
          }
        }

        if(mutation.type === 'SAVED_PROCESS') {
          if(this.deploymentSuccess) {
            this.updateLog('Process', 'Deployed', this.theProcessName, 'Process ' + this.theProcessName + ' version ' + this.theVersion + ' deployed.');
            let payload = {
              'processKey': this.theProcessKey,
              'processVersion': this.processVersion
            };
            this.$store.dispatch('markFormsDeployed', payload);
          }
        }

        if(mutation.type === 'MARKED_FORMS') {
          if(this.deploymentSuccess) {
            this.isLocked = 0;
            this.lockedBy = '';
            this.$store.commit('EDITING_PROCESS', false);
            let payload = {
              'checkType': 'unlock',
              'processId': 0,
              'processKey': this.theProcessKey,
            };
            
            this.$store.dispatch('processLockCheck', payload);
          }
        }

        if(mutation.type === 'PROCESS_LOCK_CHECK') {
          if(this.deploymentSuccess) {
            this.$store.commit('DEPLOYMENT_SUCCESS', false);
            this.$router.push({ name: 'ProcessDesigner' });
          }
        }

        if(mutation.type === 'ALL_APIS') {
          if(this.allApis.length > 0) {
            let apiArr = [];
            for(let i = 0; i < this.allApis.length; i++) {
              apiArr.push({text: this.allApis[i].FRIENDLY_NAME, val: this.allApis[i].ID});
            }
            this.targetApis = apiArr;
          }
        }

      });

      this.$store.dispatch('getAllUsers');
      this.$store.dispatch('getAllGroups');
      this.$store.dispatch('getAllTenants');
      this.$store.dispatch('getAllHqConnections');
      this.$store.dispatch('getAllApis');
      this.$store.dispatch('getAllExternalProcessXml');
      this.$store.dispatch('getAllTemplates');

      this.$store.commit('PROCESS_FORMS', []);

      if(this.processAction == 'new') {
        // New process
        this.$store.commit('UPDATE_PROCESS_KEY', '');
        this.newDiagram();
      }else {
        let payload = {
          'processKey': this.processKey
        }
        this.$store.dispatch('getProcessForms', payload);
      }

      if(this.processAction == 'import') {
        // Import process
        this.importProcess();
      }

      if(this.processAction == 'view') {
        await this.$store.dispatch('getProcessXml', this.processId).then( () => {
          // Edit process
          this.editDiagram(this.processXml);
          this.theProcessKey = this.processKey;
        });
        $(".djs-context-pad").hide()
        $(".djs-palette").hide();
      }

      if(this.processAction == 'edit') {
        this.lockedBy = this.$store.state.currentUser;
        let payload = {
          'lockedBy': this.lockedBy,
          'processKey': this.processKey,
          'version': this.processVersion
        };

        await this.$store.dispatch('getSavedProcessXml', payload).then( () => {
          // Edit process
          this.editDiagram(this.savedProcessXml);
          this.selections = this.processSelections;
          this.theProcessKey = this.processKey;
        });
      }

      this.getAvailableSignals();
      this.initProps();
    },
    beforeDestroy() {
      this.unsubscribe();
    },
    methods: {
      completeFromGlobalScope(context) {
        let nodeBefore = syntaxTree(context.state).resolveInner(context.pos, -1)
        if (completePropertyAfter.includes(nodeBefore.name) &&
            nodeBefore.parent?.name == "MemberExpression") {
          let object = nodeBefore.parent.getChild("Expression")
          if (object?.name == "VariableName") {
            let from = /\./.test(nodeBefore.name) ? nodeBefore.to : nodeBefore.from
            let variableName = context.state.sliceDoc(object.from, object.to)
            if (typeof window[variableName] == "object")
              return this.completeProperties(from, window[variableName])
          }
        } else if (nodeBefore.name == "VariableName") {
          return this.completeProperties(nodeBefore.from, window)
        } else if (context.explicit && !dontCompleteIn.includes(nodeBefore.name)) {
          return this.completeProperties(context.pos, window)
        }
        return null
      },
      completeProperties(from, object) {
        let options = []
        for (let name in object) {
          options.push({
            label: name,
            type: typeof object[name] == "function" ? "function" : "variable"
          })
        }
        return {
          from,
          options,
          validFor: /^[\w$]*$/
        }
      },
      getFormText(item) {
        return `${item.FORM_TITLE} V:${item.PROCESS_VERSION} (${item.FORM_KEY})`;
      },
      setFilter(type) {
        this.filterBy = type;
      },
      setEventFilter(style) {
        this.filterEventBy = style;
      },
      disableVariableItem(item) {
        let disable = false

        if(item.val == 'out' && this.isSignalThrowEvent) {
          disable = true
        }
        return disable
      },
      disableListenerItem(item) {
        let disable = false

        if(item.val == 'task' && this.taskType != 'bpmn:UserTask') {
          disable = true
        }
        return disable
      },
      setUpdateProps() {
        if(this.updateProps) {
          this.updateProps = false;
          this.modeStatus = this.$t('PROCESSES.BUILD_PROCESS.BTNS.MODE_BUILD');
          $(".djs-context-pad").show()
          $(".djs-palette").show()
        }else {
          this.updateProps = true;
          this.modeStatus = this.$t('PROCESSES.BUILD_PROCESS.BTNS.MODE_CONFIG');
          $(".djs-context-pad").hide()
          $(".djs-palette").hide()
        }
      },
      getProcessIds() {
        let rootElements = this.modeler._definitions.rootElements;

        for(let r = 0; r < rootElements.length; r++) {
          if(rootElements[r]['$type'] == 'bpmn:Collaboration') {
            this.collabActive = true
            this.collabEl = rootElements[r];
          }
          if(rootElements[r]['$type'] == 'bpmn:Process') {
            this.processEl = rootElements[r];
          }
        }
      },
      initProps() {
        const { modeler } = this
        this.isProcess = false
        modeler.on('selection.changed', e => {
          this.isEvent = false;
          this.isStartEvent = false;
          this.isTimerStartEvent = false;
          this.isTimerThrowEvent = false;
          this.isTimerCatchEvent = false;
          this.isTimerBoundaryEvent = false;
          this.isTimerNonBoundaryEvent = false;
          this.isConditionalStartEvent = false,
          this.isCondThrowEvent = false;
          this.isCondCatchEvent = false;
          this.isCondBoundaryEvent = false;
          this.isCondNonBoundaryEvent = false;
          this.isSignalStartEvent = false;
          this.isSignalThrowEvent = false;
          this.isSignalCatchEvent = false;
          this.isSignalBoundaryEvent = false;
          this.isSignalNonBoundaryEvent = false;
          this.isEndEvent = false;
          this.isTask = false;
          this.sendEmails = false;
          this.isCallActivity = false;
          this.isServiceTask = false;
          this.isScriptTask = false;
          this.hasLooping = false;
          this.isFlow = false;
          this.isProcess = false;
          this.isCollab = false;
          this.isLane = false;
          this.hasCondition = false;
          this.ignoreRules = false;
          this.useCaseId = false;
          this.isGateway = false;
          this.getProcessIds()
          if(this.updateProps) {
            $(".djs-context-pad").hide()
            $(".djs-palette").hide()
            if(e.newSelection.length > 0) {
              this.selectedElements = e.newSelection
              this.element = e.newSelection[0]

              if(this.element.businessObject['$type'].includes('Gateway')) {
                this.isGateway = true
                this.gatewayType = this.element.businessObject['$type']
              }

              if(this.element.businessObject['$type'] == 'bpmn:Lane') {
                this.isLane = true
              }

              if(this.element.businessObject['$type'] == 'bpmn:Participant') {
                this.participantId = this.element.businessObject.id
                this.currentParticipantId = this.participantId
                this.participantName = this.element.businessObject.name

                this.isProcess = true
                let processRef = this.element.businessObject.processRef
                this.elementId = processRef.id
                this.elementName = processRef.name

                if(processRef.candidateStarterUsers) {
                  this.candidateStarterUsers = []
                  let users = processRef.candidateStarterUsers.split(',')
                  let tmpArr = []
                  let ref = this
                  users.forEach(function(value) {
                    if(value.includes('${')) {
                      tmpArr.push(value)
                    }else {
                      for(let u = 0; u < ref.allUsers.length; u++) {
                        if(ref.allUsers[u].id == value) {
                          tmpArr.push({ fullName: ref.allUsers[u].fullName, id: value })
                        }
                      }
                    }
                  })
                  this.candidateStarterUsers = tmpArr
                }

                if(processRef.candidateStarterGroups) {
                  this.candidateStarterGroups = []
                  let groups = processRef.candidateStarterGroups.split(',')
                  let tmpArr = []
                  let ref = this
                  groups.forEach(function(value) {
                    if(value.includes('${')) {
                      tmpArr.push(value)
                    }else {
                      for(let g = 0; g < ref.allGroups.length; g++) {
                        if(ref.allGroups[g].id == value) {
                          tmpArr.push({ name: ref.allGroups[g].name, id: value })
                        }
                      }
                    }
                  })
                  this.candidateStarterGroups = tmpArr
                }

                if(processRef.historyTimeToLive) {
                  this.historyTimeToLive = processRef.historyTimeToLive
                }

                if('isExecutable' in processRef) {
                  // this.isExecutable = processRef.isExecutable
                  this.isExecutable = true
                }

                if('isStartableInTasklist' in processRef) {
                  this.isStartable = processRef.isStartableInTasklist
                }

                if(processRef.calledElement) {
                  this.calledElement = processRef.calledElement
                }

                if(processRef.documentation && processRef.documentation.length > 0) {
                  this.elementNotes = processRef.documentation[0].text
                }else {
                  this.elementNotes = ''
                }

                this.extensionItems = []
                if(processRef.extensionElements) {
                  let index = 0
                  for(let i = 0; i < processRef.extensionElements.values.length; i++) {
                    let lType = ''
                    if(processRef.extensionElements.values[i]['$type'].includes('Execution')) {
                      lType = 'execution'
                    }

                    this.extensionItems.push({ id: index, extId: i, type: 'listener', listenerType: lType, listenerEventType: processRef.extensionElements.values[i].event })
                    index++
                  }
                }
              }else {
                this.elementId = this.element.businessObject.id
                this.elementName = this.element.businessObject.name

                if(this.element.businessObject.formKey) {
                  if(this.element.businessObject.formKey.includes('${')) {
                    this.formKey = this.element.businessObject.formKey
                  }else {
                    for(let f = 0; f < this.processForms.length; f++) {
                      if(this.element.businessObject.formKey == this.processForms[f].FORM_KEY) {
                        this.formKey = this.processForms[f].FORM_TITLE + ' V:' + this.processForms[f].PROCESS_VERSION + ' (' + this.processForms[f].FORM_KEY + ')';
                        break
                      }
                    }
                  }
                }
                
                if(this.element.businessObject.calledElement) {
                  this.calledElement = this.element.businessObject.calledElement
                  
                  // API Controller specifics
                  if(this.calledElement == 'apiController') {
                    if(this.element.businessObject.extensionElements) {
                      for(let i = 0; i < this.element.businessObject.extensionElements.values.length; i++) {
                        if(this.element.businessObject.extensionElements.values[i].$type == 'harlequin:ExecutionListener') {
                          if(this.element.businessObject.extensionElements.values[i].event == 'start') {
                            let apiScript = this.element.businessObject.extensionElements.values[i].script.value
                            let strIndex = 0
                            
                            // Get API ID
                            strIndex = apiScript.indexOf('id", ', strIndex)
                            if(strIndex != -1) {
                              strIndex += 5
                              this.targetApi = parseInt(apiScript.substring(strIndex, apiScript.indexOf(');', strIndex)))
                              
                              for(let i = 0; i < this.allApis.length; i++) {
                                if(this.allApis[i].ID == this.targetApi) {
                                  this.grantType = this.allApis[i].GRANT_TYPE
                                }
                              }
                            }
                            
                            // Get Call Type
                            strIndex = 0
                            strIndex = apiScript.indexOf('callType", "', strIndex)
                            if(strIndex != -1) {
                              strIndex += 12
                              this.apiCallType = apiScript.substring(strIndex, apiScript.indexOf('");', strIndex))
                            }

                            // Get Grant Type
                            strIndex = 0
                            strIndex = apiScript.indexOf('includeGrantType", ', strIndex)
                            if(strIndex != -1) {
                              strIndex += 19
                              let boolVal = apiScript.substring(strIndex, apiScript.indexOf(');', strIndex))
                              this.includeGrantType = boolVal == 'true'
                            }

                            // Get Client ID
                            strIndex = 0
                            strIndex = apiScript.indexOf('includeClientId", ', strIndex)
                            if(strIndex != -1) {
                              strIndex += 18
                              let boolVal = apiScript.substring(strIndex, apiScript.indexOf(');', strIndex))
                              this.includeClientId = boolVal == 'true'
                            }

                            // Get Client Secret
                            strIndex = 0
                            strIndex = apiScript.indexOf('includeClientSecret", ', strIndex)
                            if(strIndex != -1) {
                              strIndex += 22
                              let boolVal = apiScript.substring(strIndex, apiScript.indexOf(');', strIndex))
                              this.includeClientSecret = boolVal == 'true'
                            }

                            // Get URL Query
                            strIndex = 0
                            strIndex = apiScript.indexOf('urlQuery", "', strIndex)
                            if(strIndex != -1) {
                              strIndex += 12
                              this.apiUrlQuery = apiScript.substring(strIndex, apiScript.indexOf('");', strIndex))
                              this.apiUrlQuery = this.apiUrlQuery.replaceAll('\\', '')
                            }

                            // Get POST Data
                            strIndex = 0
                            strIndex = apiScript.indexOf('postData", "', strIndex)
                            if(strIndex != -1) {
                              strIndex += 12
                              this.apiPostData = apiScript.substring(strIndex, apiScript.indexOf('");', strIndex))
                              this.apiPostData = this.apiPostData.replaceAll('\\', '')
                            }

                            // Get Parameters
                            strIndex = 0
                            strIndex = apiScript.indexOf('apiParams", "', strIndex)
                            if(strIndex != -1) {
                              strIndex += 13
                              let apiParams = apiScript.substring(strIndex, apiScript.indexOf('");', strIndex))
                              apiParams = apiParams.replaceAll('\\', '')
                              this.apiParamItems = JSON.parse(apiParams)
                            }

                            // Get Headers
                            strIndex = 0
                            strIndex = apiScript.indexOf('apiHeaders", "', strIndex)
                            if(strIndex != -1) {
                              strIndex += 14
                              let apiHeaders = apiScript.substring(strIndex, apiScript.indexOf('");', strIndex))
                              apiHeaders = apiHeaders.replaceAll('\\', '')
                              this.apiHeaderItems = JSON.parse(apiHeaders)
                            }
                          }
                        }
                      }
                    }
                  }
                }

                if(this.element.businessObject.calledElementTenantId) {
                  this.tenantId = this.element.businessObject.calledElementTenantId
                }

                if(this.element.businessObject.assignee) {
                  let assignees = this.element.businessObject.assignee;

                  if(assignees.includes('${')) {
                    this.assignee = assignees
                  }else {
                    for(let u = 0; u < this.allUsers.length; u++) {
                      if(this.allUsers[u].id == assignees) {
                        this.assignee = { fullName: this.allUsers[u].fullName, id: assignees }
                      }
                    }
                  }
                }

                if(this.element.businessObject.candidateUsers) {
                  this.candidateUsers = []
                  let users = this.element.businessObject.candidateUsers.split(',')
                  let tmpArr = []
                  let ref = this
                  users.forEach(function(value) {
                    if(value.includes('${')) {
                      tmpArr.push(value)
                    }else {
                      for(let u = 0; u < ref.allUsers.length; u++) {
                        if(ref.allUsers[u].id == value) {
                          tmpArr.push({ fullName: ref.allUsers[u].fullName, id: value })
                        }
                      }
                    }
                  })
                  this.candidateUsers = tmpArr
                }

                if(this.element.businessObject.candidateGroups) {
                  this.candidateGroups = []
                  let groups = this.element.businessObject.candidateGroups.split(',')
                  let tmpArr = []
                  let ref = this
                  groups.forEach(function(value) {
                    if(value.includes('${')) {
                      tmpArr.push(value)
                    }else {
                      for(let g = 0; g < ref.allGroups.length; g++) {
                        if(ref.allGroups[g].id == value) {
                          tmpArr.push({ name: ref.allGroups[g].name, id: value })
                        }
                      }
                    }
                  })
                  this.candidateGroups = tmpArr
                }

                if(this.element.businessObject.dueDate) {
                  this.dueDate = this.element.businessObject.dueDate
                }

                if(this.element.businessObject.followUpDate) {
                  this.followUpDate = this.element.businessObject.followUpDate
                }

                if(this.element.businessObject.class) {
                  this.javaClass = this.element.businessObject.class
                }else {
                  this.javaClass = ''
                }

                if(this.element.businessObject.resultVariable) {
                  this.scriptResultVariable = this.element.businessObject.resultVariable
                }else {
                  this.scriptResultVariable = ''
                }

                if(this.element.businessObject.script) {
                  this.taskScript = this.element.businessObject.script
                }else {
                  this.taskScript = this.defaultScript
                }

                if(this.element.businessObject.documentation && this.element.businessObject.documentation.length > 0) {
                  this.elementNotes = this.element.businessObject.documentation[0].text
                }else {
                  this.elementNotes = ''
                }

                if(this.element.businessObject.loopCharacteristics) {
                  if(this.element.businessObject.loopCharacteristics.loopCardinality) {
                    this.multiInstanceCount = this.element.businessObject.loopCharacteristics.loopCardinality.body
                  }
                  if(this.element.businessObject.loopCharacteristics.completionCondition) {
                    this.completionCondition = this.element.businessObject.loopCharacteristics.completionCondition.body
                  }
                }

                if(this.element.businessObject.eventDefinitions) {
                  if(this.element.businessObject.eventDefinitions[0].timeDate) {
                    this.timerDefType = 'date'
                    this.timerDefinition = this.element.businessObject.eventDefinitions[0].timeDate.body
                  }
                  if(this.element.businessObject.eventDefinitions[0].timeDuration) {
                    this.timerDefType = 'duration'
                    this.timerDefinition = this.element.businessObject.eventDefinitions[0].timeDuration.body
                  }
                  if(this.element.businessObject.eventDefinitions[0].timeCycle) {
                    this.timerDefType = 'cycle'
                    this.timerDefinition = this.element.businessObject.eventDefinitions[0].timeCycle.body
                  }
                  if(this.element.businessObject.eventDefinitions[0].variableName) {
                    this.startVarName = this.element.businessObject.eventDefinitions[0].variableName
                  }else {
                    this.startVarName = ''
                  }
                  if(this.element.businessObject.eventDefinitions[0].condition) {
                    this.startCondition = this.element.businessObject.eventDefinitions[0].condition.body
                  }else {
                    this.startCondition = ''
                  }
                  if(this.element.businessObject.eventDefinitions[0].signalRef) {
                    this.startSignalId = this.element.businessObject.eventDefinitions[0].signalRef.id
                    this.startSignalName = this.element.businessObject.eventDefinitions[0].signalRef.name
                  }else {
                    this.startSignalId = ''
                    this.startSignalName = ''
                  }
                  if(this.element.businessObject.eventDefinitions[0].variableEvents) {
                    this.varEvents = this.element.businessObject.eventDefinitions[0].variableEvents
                  }else {
                    this.varEvents = ''
                  }
                }

                this.extensionItems = []
                if(this.element.businessObject.extensionElements) {
                  let index = 0
                  for(let i = 0; i < this.element.businessObject.extensionElements.values.length; i++) {
                    if(this.element.businessObject.extensionElements.values[i].businessKey) {
                      this.useCaseId = true
                    }
                    if(this.element.businessObject.extensionElements.values[i].event) {
                      let lType = ''
                      let listTaskType = ''
                      if(this.element.businessObject.extensionElements.values[i]['$type'].includes('Execution')) {
                        lType = 'execution'
                      }
                      if(this.element.businessObject.extensionElements.values[i]['$type'].includes('Task')) {
                        lType = 'task'
                        
                        if(this.element.businessObject.extensionElements.values[i]['class'] && this.element.businessObject.extensionElements.values[i]['class'].includes('EmailListener')) {
                          this.sendEmails = true;
                          if(this.element.businessObject.extensionElements.values[i].event == 'create') {
                            listTaskType = 'sendEmails';
                          }
                        }else {
                          if(this.element.businessObject.extensionElements.values[i].event == 'create') {
                            if(this.element.businessObject.extensionElements.values[i].script && this.element.businessObject.extensionElements.values[i].script.value) {
                              if(this.element.businessObject.extensionElements.values[i].script.value.includes('templateKey')) {
                                listTaskType = 'sendEmailsScript';

                                let tempStr = this.element.businessObject.extensionElements.values[i].script.value;
                                let tempStrArr = tempStr.split('task.setVariable("templateKey", "');
                                let tempStrArr2 = tempStrArr[1].split('");');
                                let tempStrArr3 = tempStrArr2[1].split('\ntask.setVariable("emailSubject", "');

                                this.emailTemplate = tempStrArr2[0];

                                this.emailSubject = tempStrArr3[1];
                              }
                            }
                          }
                        }
                      }
                      this.extensionItems.push({ id: index, extId: i, type: 'listener', listenerType: lType, listenerEventType: this.element.businessObject.extensionElements.values[i].event, listTaskType: listTaskType })
                      index++
                    }
                    if(this.element.businessObject.extensionElements.values[i].variables || this.element.businessObject.extensionElements.values[i].source) {
                      let inOut = ''
                      let varType = ''
                      let source = ''
                      let target = ''
                      if(this.element.businessObject.extensionElements.values[i]['$type'].includes('In')) {
                        inOut = 'in'
                        if(this.element.businessObject.extensionElements.values[i].variables) {
                          varType = 'all'
                        }else {
                          varType = 'source'
                          source = this.element.businessObject.extensionElements.values[i].source
                          target = this.element.businessObject.extensionElements.values[i].target
                        }
                      }
                      if(this.element.businessObject.extensionElements.values[i]['$type'].includes('Out')) {
                        inOut = 'out'
                        if(this.element.businessObject.extensionElements.values[i].variables) {
                          varType = 'all'
                        }else {
                          varType = 'source'
                          source = this.element.businessObject.extensionElements.values[i].source
                          target = this.element.businessObject.extensionElements.values[i].target
                        }
                      }
                      this.extensionItems.push({ id: index, extId: i, type: 'variable', variableInOut: inOut, variableType: varType, variableSource: source, variableTarget: target })
                      index++
                    }
                  }
                }
                if(this.element.businessObject.eventDefinitions && this.element.businessObject.eventDefinitions[0].extensionElements) {
                  for(let j = 0; j < this.element.businessObject.eventDefinitions[0].extensionElements.values.length; j++) {
                    if(this.element.businessObject.eventDefinitions[0].extensionElements.values[j].variables || this.element.businessObject.eventDefinitions[0].extensionElements.values[j].source) {
                      let inOut = ''
                      let varType = ''
                      let source = ''
                      let target = ''
                      if(this.element.businessObject.eventDefinitions[0].extensionElements.values[j]['$type'].includes('In')) {
                        inOut = 'in'
                        if(this.element.businessObject.eventDefinitions[0].extensionElements.values[j].variables) {
                          varType = 'all'
                        }else {
                          varType = 'source'
                          source = this.element.businessObject.eventDefinitions[0].extensionElements.values[j].source
                          target = this.element.businessObject.eventDefinitions[0].extensionElements.values[j].target
                        }
                      }
                      let index = this.extensionItems.length
                      this.extensionItems.push({ id: index, sigId: j, type: 'variable', variableInOut: inOut, variableType: varType, variableSource: source, variableTarget: target })
                    }
                  }
                }

                if(this.element.businessObject.sourceRef && (this.element.businessObject.sourceRef['$type'].includes('Task') || this.element.businessObject.sourceRef['$type'].includes('Gateway'))) {
                  this.hasCondition = true;

                  if(this.element.businessObject.sourceRef['$type'].includes('Parallel')) {
                    this.hasCondition = false;
                  }

                  if(this.element.businessObject.sourceRef['$type'].includes('Task') || this.element.businessObject.sourceRef['$type'].includes('Parallel')) {
                    this.ignoreRules = true;
                  }

                  if(this.element.businessObject.conditionExpression) {
                    this.conditionType = 'expression';
                    this.condition = this.element.businessObject.conditionExpression.body;
                  }else {
                    this.conditionType = 'expression';
                    this.condition = '';
                  }
                }else {
                  this.conditionType = 'expression';
                  this.condition = '';
                }
              }
              this.setDefaultProperties()
            }else {
              // Do nothing
            }
          }else {
            if(this.processAction != 'view') {
              $(".djs-context-pad").show()
              $(".djs-palette").show()
            }else {
              $(".djs-context-pad").hide()
              $(".djs-palette").hide()
            }
          }
        })
      },
      configureProcess() {
        const { modeler } = this
        let rootElements = this.modeler._definitions.rootElements;
        this.getProcessIds();

        this.isEvent = false;
        this.isStartEvent = false;
        this.isTimerStartEvent = false;
        this.isTimerThrowEvent = false;
        this.isTimerCatchEvent = false;
        this.isTimerBoundaryEvent = false;
        this.isTimerNonBoundaryEvent = false;
        this.isConditionalStartEvent = false,
        this.isCondThrowEvent = false;
        this.isCondCatchEvent = false;
        this.isCondBoundaryEvent = false;
        this.isCondNonBoundaryEvent = false;
        this.isSignalStartEvent = false;
        this.isSignalThrowEvent = false;
        this.isSignalCatchEvent = false;
        this.isSignalBoundaryEvent = false;
        this.isSignalNonBoundaryEvent = false;
        this.isEndEvent = false;
        this.isTask = false;
        this.isCallActivity = false;
        this.isServiceTask = false;
        this.isScriptTask = false;
        this.hasLooping = false;
        this.isFlow = false;
        this.isProcess = false;
        this.isCollab = false;
        this.isLane = false;
        this.hasCondition = false;
        this.ignoreRules = false;
        this.isGateway = false;
        
        for(let r = 0; r < rootElements.length; r++) {
          if(rootElements[r]['$type'] == 'bpmn:Collaboration') {
            this.isCollab = true
          }
        }

        const elementRegistry = modeler.get('elementRegistry')
        let element = '';

        if(this.isCollab) {
          let elKeys = Object.keys(elementRegistry._elements)

          elKeys.forEach((key) => {
            if(key.startsWith('Participant_')) {
              element = elementRegistry._elements[key].element

              this.participantId = element.businessObject.id
              this.currentParticipantId = this.participantId
              this.participantName = element.businessObject.name

              this.isProcess = true
              let processRef = element.businessObject.processRef
              this.elementId = processRef.id
              this.elementName = processRef.name

              if(processRef.candidateStarterUsers) {
                this.candidateStarterUsers = []
                let users = processRef.candidateStarterUsers.split(',')
                let tmpArr = []
                let ref = this
                users.forEach(function(value) {
                  if(value.includes('${')) {
                    tmpArr.push(value)
                  }else {
                    for(let u = 0; u < ref.allUsers.length; u++) {
                      if(ref.allUsers[u].id == value) {
                        tmpArr.push({ fullName: ref.allUsers[u].fullName, id: value })
                      }
                    }
                  }
                })
                this.candidateStarterUsers = tmpArr
              }

              if(processRef.candidateStarterGroups) {
                this.candidateStarterGroups = []
                let groups = processRef.candidateStarterGroups.split(',')
                let tmpArr = []
                let ref = this
                groups.forEach(function(value) {
                  if(value.includes('${')) {
                    tmpArr.push(value)
                  }else {
                    for(let g = 0; g < ref.allGroups.length; g++) {
                      if(ref.allGroups[g].id == value) {
                        tmpArr.push({ name: ref.allGroups[g].name, id: value })
                      }
                    }
                  }
                })
                this.candidateStarterGroups = tmpArr
              }

              if(processRef.historyTimeToLive) {
                this.historyTimeToLive = processRef.historyTimeToLive
              }

              if('isExecutable' in processRef) {
                // this.isExecutable = processRef.isExecutable
                this.isExecutable = true
              }

              if('isStartableInTasklist' in processRef) {
                this.isStartable = processRef.isStartableInTasklist
              }

              if(processRef.calledElement) {
                this.calledElement = processRef.calledElement
              }

              if(processRef.documentation && processRef.documentation.length > 0) {
                this.elementNotes = processRef.documentation[0].text
              }else {
                this.elementNotes = ''
              }

              this.extensionItems = []
              if(processRef.extensionElements) {
                let index = 0
                for(let i = 0; i < processRef.extensionElements.values.length; i++) {
                  let lType = ''
                  if(processRef.extensionElements.values[i]['$type'].includes('Execution')) {
                    lType = 'execution'
                  }

                  this.extensionItems.push({ id: index, extId: i, type: 'listener', listenerType: lType, listenerEventType: processRef.extensionElements.values[i].event })
                  index++
                }
              }
            }
          });
          // this.elementId = this.collabEl.id

          // if(this.collabEl.documentation.length > 0) {
          //   this.elementNotes = this.collabEl.documentation[0].text
          // }else {
          //   this.elementNotes = ''
          // }
        }else {
          element = elementRegistry._elements[this.processEl.id].element

          this.isProcess = true
          this.elementId = element.businessObject.id
          this.elementName = element.businessObject.name

          if(element.businessObject.candidateStarterUsers) {
            this.candidateStarterUsers = []
            let users = element.businessObject.candidateStarterUsers.split(',')
            let tmpArr = []
            let ref = this
            users.forEach(function(value) {
              if(value.includes('${')) {
                tmpArr.push(value)
              }else {
                for(let u = 0; u < ref.allUsers.length; u++) {
                  if(ref.allUsers[u].id == value) {
                    tmpArr.push({ fullName: ref.allUsers[u].fullName, id: value })
                  }
                }
              }
            })
            this.candidateStarterUsers = tmpArr
          }

          if(element.businessObject.candidateStarterGroups) {
            this.candidateStarterGroups = []
            let groups = element.businessObject.candidateStarterGroups.split(',')
            let tmpArr = []
            let ref = this
            groups.forEach(function(value) {
              if(value.includes('${')) {
                tmpArr.push(value)
              }else {
                for(let g = 0; g < ref.allGroups.length; g++) {
                  if(ref.allGroups[g].id == value) {
                    tmpArr.push({ name: ref.allGroups[g].name, id: value })
                  }
                }
              }
            })
            this.candidateStarterGroups = tmpArr
          }

          if(element.businessObject.historyTimeToLive) {
            this.historyTimeToLive = element.businessObject.historyTimeToLive
          }

          if('isExecutable' in element.businessObject) {
            // this.isExecutable = element.businessObject.isExecutable
            this.isExecutable = true
          }

          if('isStartableInTasklist' in element.businessObject) {
            this.isStartable = element.businessObject.isStartableInTasklist
          }

          if(element.businessObject.calledElement) {
            this.calledElement = element.businessObject.calledElement
          }

          if(element.businessObject.documentation && element.businessObject.documentation.length > 0) {
            this.elementNotes = element.businessObject.documentation[0].text
          }else {
            this.elementNotes = ''
          }

          this.extensionItems = []
          if(element.businessObject.extensionElements) {
            let index = 0
            for(let i = 0; i < element.businessObject.extensionElements.values.length; i++) {
              let lType = ''
              if(element.businessObject.extensionElements.values[i]['$type'].includes('Execution')) {
                lType = 'execution'
              }
              if(element.businessObject.extensionElements.values[i]['$type'].includes('Task')) {
                lType = 'task'
              }
              this.extensionItems.push({ id: index, extId: i, type: 'listener', listenerType: lType, listenerEventType: element.businessObject.extensionElements.values[i].event })
              index++
            }
          }
        }
        if(this.processAction == 'new' && !this.processIdSet) {
          this.changeField(this.newProcName, 'id');
          this.elementId = this.newProcName;
          this.processIdSet = true;
        }
        this.propsDialog = true
      },
      setDefaultProperties() {
        const { element } = this
        if (element) {
          const { type, businessObject } = element
          const { name } = businessObject
          if (this.verifyIsEvent(type)) {
            this.isEvent = true;
            this.eventType = businessObject.eventDefinitions ? businessObject.eventDefinitions[0]['$type'] : ''
            
            if(type.includes('Start')) {
              this.isStartEvent = true;
              this.setEventFilter('start')
            }
            if(type.includes('Intermediate')) {
              if(this.eventType.includes('Timer')) {
                if(type.includes('Throw')) {
                  this.eventType = 'interTimerThrow'
                  this.isTimerThrowEvent = true
                }else {
                  this.eventType = 'interTimerCatch'
                  this.isTimerCatchEvent = true
                }
              }
              if(this.eventType.includes('Conditional')) {
                if(type.includes('Throw')) {
                  this.eventType = 'interCondThrow'
                  this.isCondThrowEvent = true
                }else {
                  this.eventType = 'interCondCatch'
                  this.isCondCatchEvent = true
                }
              }
              if(this.eventType.includes('Signal')) {
                if(type.includes('Throw')) {
                  this.eventType = 'interSignalThrow'
                  this.isSignalThrowEvent = true
                }else {
                  this.eventType = 'interSignalCatch'
                  this.isSignalCatchEvent = true
                }
              }
              this.setEventFilter('inter')
            }
            if(type.includes('Boundary')) {
              if(this.eventType.includes('Timer')) {
                if(element.businessObject.cancelActivity) {
                  this.eventType = 'boundaryTimer'
                  this.isTimerBoundaryEvent = true
                }else {
                  this.eventType = 'boundaryTimerNon'
                  this.isTimerNonBoundaryEvent = true
                }
              }
              if(this.eventType.includes('Conditional')) {
                if(element.businessObject.cancelActivity) {
                  this.eventType = 'boundaryCond'
                  this.isCondBoundaryEvent = true
                }else {
                  this.eventType = 'boundaryCondNon'
                  this.isCondNonBoundaryEvent = true
                }
              }
              if(this.eventType.includes('Signal')) {
                if(element.businessObject.cancelActivity) {
                  this.eventType = 'boundarySignal'
                  this.isSignalBoundaryEvent = true
                }else {
                  this.eventType = 'boundarySignalNon'
                  this.isSignalNonBoundaryEvent = true
                }
              }
              this.setEventFilter('boundary')
            }
            if(type.includes('End')) {
              this.isEndEvent = true;
              this.eventType = 'bpmn:EndEvent';
              this.setEventFilter('end')
            }
            if(this.eventType.includes('Timer')) {
              this.isTimerStartEvent = true;
            }
            if(this.eventType.includes('Conditional')) {
              this.isConditionalStartEvent = true;
            }
            if(this.eventType.includes('Signal')) {
              this.isSignalStartEvent = true;
            }
            
            if(!this.eventType) {
              this.eventType = 'bpmn:StartEvent';
            }
          } else if (this.verifyIsTask(type)) {
            this.isTask = true;
            // Dymanically retrieve forms
            let payload = {
              'processKey': this.processKey
            }
            this.$store.dispatch('getProcessForms', payload);

            if(type == 'bpmn:Task') {
              this.changeTaskType('bpmn:UserTask')
            }else {
              this.taskType = type
            }

            if(type.includes('Call')) {
              this.isCallActivity = true;
              for(let i = 0; i < this.allProcessXml.length; i++) {
                this.calledElementItems.push({ text: this.allProcessXml[i].PROCESS_NAME, val: this.allProcessXml[i].PROCESS_KEY})
              }
            }

            if(type.includes('Service')) {
              this.isServiceTask = true;
            }

            if(type.includes('Script')) {
              this.isScriptTask = true;
            }

            // Do we have looping set?
            if(element.businessObject.loopCharacteristics) {
              this.hasLooping = true;
            }

          } else if (this.verifyIsFlow(type)) {
            this.isFlow = true;
          }
          element['name'] = name
          this.propsDialog = true
        }
      },
      verifyIsEvent(type) {
        return type.includes('Event')
      },
      verifyIsTask(type) {
        return type.includes('Task') || type.includes('Activity')
      },
      verifyIsFlow(type) {
        return type.includes('Flow')
      },
      changeField(event, type) {
        if(type == 'id') {
          // Remove spaces from Process ID
          event = event.replace(/\s+/g, '');
        }

        if(type == 'formKey') {
          if(typeof event === 'object') {
            event = event.FORM_KEY
          }
        }
        
        if(type == 'candidateUsers' || type == 'candidateGroups' || type == 'candidateStarterUsers' || type == 'candidateStarterGroups') {
          let ids = ''
          if(Array.isArray(event)) {
            for(let i = 0; i < event.length; i++) {
              if(typeof event[i] === 'object') {
                ids += event[i].id + ','
              }else {
                ids += event[i] + ','
              }
            }
            event = ids.replace(/,\s*$/, "");
          }else {
            event = event.toString()
          }
        }

        if(type == 'assignee') {
          if(!event) {
            event = null;
          }else {
            if(typeof event === 'object') {
              event = event.id
            }else {
              event = event.toString()
            }
          }
        }

        if(type == 'targetApi') {
          for(let i = 0; i < this.allApis.length; i++) {
            if(this.allApis[i].ID == event) {
              this.grantType = this.allApis[i].GRANT_TYPE
            }
          }
        }
        
        let element = this.processEl;
        this.currentProcessId = element.id
        
        const value = event
        
        let properties = {}

        if(type == 'documentation') {
          properties[type] = { text: value }
        }else if(type == 'condition') {
          if(this.conditionType == '') {
            properties[type] = { body: '' }
          }else {
            properties[type] = { body: value }
          }
        }else {
          properties[type] = value
        }
        
        this.updateProperties(properties)
      },
      changeEventType(event) {
        const { modeler, element } = this
        const value = event
        const bpmnReplace = modeler.get('bpmnReplace')
        this.eventType = value

        if(value == 'interTimerCatch' || value == 'interCondCatch' || value == 'interSignalCatch' || value == 'interSignalThrow' || value == 'boundaryTimer' || 
          value == 'boundaryCond' || value == 'boundarySignal' || value == 'boundaryTimerNon' || value == 'boundaryCondNon' || value == 'boundarySignalNon') {
          
          let eType = ''
          let type = ''
          let cancelActivity = true

          for(let i = 0; i < this.eventTypes.length; i++) {
            if(this.eventTypes[i].value == value) {
              eType = this.eventTypes[i].type

              if(value.includes('Catch')) {
                type = 'bpmn:IntermediateCatchEvent'
              }else if(value.includes('Throw')) {
                type = 'bpmn:IntermediateThrowEvent'
              }else {
                type = 'bpmn:BoundaryEvent'
              }
              break;
            }
          }

          if(value.includes('Non')) {
            cancelActivity = false
          }

          bpmnReplace.replaceElement(element, {
            type: type,
            eventDefinitionType: eType,
            cancelActivity: cancelActivity
          })
        }else {
          bpmnReplace.replaceElement(element, {
            type: element.businessObject.$type,
            eventDefinitionType: value
          })
        }
      },
      changeTaskType(event) {
        const { modeler, element } = this
        const value = event
        const bpmnReplace = modeler.get('bpmnReplace')
        bpmnReplace.replaceElement(element, {
          type: value
        })
      },
      changeSendEmails(event) {
        let element = this.processEl;
        this.currentProcessId = element.id

        let properties = {
          'listener': {
            'lType': 'task',
            'sendEmails': event
          }
        }

        if(event) {
          let emailSubject = ''
          if(typeof this.emailSubject !== 'undefined') {
            emailSubject = this.emailSubject
          }

          let lScript = 'task.setVariable("templateKey", "' + this.emailTemplate + '");\n'
          lScript += 'task.setVariable("emailSubject", "' + emailSubject + '");'

          properties['listener']['lScript'] = lScript;
          properties['listener']['action'] = 'new';
        }else {
          properties['listener']['action'] = 'remove';
        }
        
        this.updateProperties(properties)
      },
      changeEmailTemplate(event) {
        this.emailTemplate = event.TEMP_KEY;
        let element = this.processEl;
        this.currentProcessId = element.id
        let emailSubject = ''

        if(typeof this.emailSubject !== 'undefined') {
          emailSubject = this.emailSubject
        }

        let lScript = 'task.setVariable("templateKey", "' + this.emailTemplate + '");\n'
        lScript += 'task.setVariable("emailSubject", "' + emailSubject + '");'

        let properties = {
          'listener': {
            'lType': 'task',
            'sendEmails': true,
            'lScript': lScript,
            'action': 'update'
          }
        }
        
        this.updateProperties(properties)
      },
      changeEmailSubject(event) {
        let element = this.processEl;
        this.currentProcessId = element.id

        let lScript = 'task.setVariable("templateKey", "' + this.emailTemplate + '");\n'
        lScript += 'task.setVariable("emailSubject", "' + event + '");'

        let properties = {
          'listener': {
            'lType': 'task',
            'sendEmails': true,
            'lScript': lScript,
            'action': 'update'
          }
        }
        
        this.updateProperties(properties)
      },
      getAvailableSignals() {
        this.availableSignals = []
        if(this.modeler._definitions) {
          let elements = this.modeler._definitions.rootElements
          for(let i = 0; i < elements.length; i++) {
            if(elements[i]['$type'] == 'bpmn:Signal') {
              this.availableSignals.push({ id: elements[i].id, name: elements[i].name })
            }
          }
        }
      },
      deleteSignal() {
        let rootElements = this.modeler._definitions.rootElements;
        let removed = false;
        // Loop through existing root elements
        for(let i = 0; i < rootElements.length; i++) {
          if(rootElements[i]['$type'].includes('Signal')) {
            if(rootElements[i].id == this.startSignalName.id) {
              // Match, so remove element
              rootElements.splice(i, 1);
              removed = true;
            }
          }
        }
        if(removed) {
          this.startSignalName = '';
          this.getAvailableSignals();
        }
      },
      updateProperties(properties) {
        const { modeler, element } = this
        const modeling = modeler.get('modeling')
        const bpmnFactory = modeler.get('bpmnFactory')
        
        if(properties.documentation && !this.isProcess && !this.isCollab) {
          let doc = bpmnFactory.create('bpmn:Documentation')
          doc.text = properties.documentation.text
          modeling.updateProperties(element, { documentation: [doc] })
        }else if(properties.timerDefinitionType) {
          delete element.businessObject.eventDefinitions[0].timeDate
          delete element.businessObject.eventDefinitions[0].timeDuration
          delete element.businessObject.eventDefinitions[0].timeCycle
          this.timerDefinition = ''
          if(properties.timerDefinitionType == 'date') {
            let dateExpr = bpmnFactory.create('bpmn:FormalExpression', { body: '' })
            element.businessObject.eventDefinitions[0].timeDate = dateExpr
          }
          if(properties.timerDefinitionType == 'duration') {
            let durExpr = bpmnFactory.create('bpmn:FormalExpression', { body: '' })
            element.businessObject.eventDefinitions[0].timeDuration = durExpr
          }
          if(properties.timerDefinitionType == 'cycle') {
            let cycleExpr = bpmnFactory.create('bpmn:FormalExpression', { body: '' })
            element.businessObject.eventDefinitions[0].timeCycle = cycleExpr
          }
        }else if(properties.timerDefinition) {
          if(this.timerDefType == 'date') {
            element.businessObject.eventDefinitions[0].timeDate.body = properties.timerDefinition
          }
          if(this.timerDefType == 'duration') {
            element.businessObject.eventDefinitions[0].timeDuration.body = properties.timerDefinition
          }
          if(this.timerDefType == 'cycle') {
            element.businessObject.eventDefinitions[0].timeCycle.body = properties.timerDefinition
          }
        }else if(properties.startVarName) {
          element.businessObject.eventDefinitions[0].variableName = properties.startVarName
        }else if(properties.startCondition) {
          let condExpr = bpmnFactory.create('bpmn:FormalExpression', { body: properties.startCondition })
          element.businessObject.eventDefinitions[0].condition = condExpr
        }else if(properties.varEvents) {
          element.businessObject.eventDefinitions[0].variableEvents = properties.varEvents
        }else if(properties.multiInstanceCount) {
          if(properties.multiInstanceCount != '') {
            let condExpr = bpmnFactory.create('bpmn:FormalExpression', { body: properties.multiInstanceCount })
            element.businessObject.loopCharacteristics.loopCardinality = condExpr
          }else {
            delete element.businessObject.loopCharacteristics.loopCardinality
          }
        }else if(properties.completionCondition) {
          if(properties.completionCondition != '') {
            let condExpr = bpmnFactory.create('bpmn:FormalExpression', { body: properties.completionCondition })
            element.businessObject.loopCharacteristics.completionCondition = condExpr
          }else {
            delete element.businessObject.loopCharacteristics.completionCondition
          }
        }else if(properties.startSignalName) {
          let signalExists = false
          let sigId = ''
          let sigName = ''

          for(let i = 0; i < this.availableSignals.length; i++) {
            if(this.availableSignals[i].name == properties.startSignalName.name) {
              signalExists = true
              sigId = this.availableSignals[i].id
              sigName = this.availableSignals[i].name
              break
            }
          }

          if(!signalExists) {
            let chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
            let signalId = 'Signal_'

            // Generate ID
            for (let j = 0; j < 7; j++) {
                signalId += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            this.startSignalId = signalId
            let signal = bpmnFactory.create('bpmn:Signal', { id: signalId, name: properties.startSignalName })
            element.businessObject.eventDefinitions[0].signalRef = signal
            this.modeler._definitions.rootElements.push(signal)
            this.getAvailableSignals()
          }else {
            let signal = bpmnFactory.create('bpmn:Signal', { id: sigId, name: sigName })
            element.businessObject.eventDefinitions[0].signalRef = signal
          }
        }else if(properties.condition) {
          if(properties.condition.body != '') {
            let condExpr = bpmnFactory.create('bpmn:FormalExpression', { body: properties.condition.body })
            modeling.updateProperties(element, { conditionExpression: condExpr })
          }else {
            delete element.businessObject.conditionExpression
          }
        }else if(properties.listener && !this.isProcess) {
          if(!element.businessObject.extensionElements) {
            let valArr = []
            let listTaskType = ''

            if(properties.listener.lType == 'execution') {
              let theScript = bpmnFactory.create('harlequin:Script', { scriptFormat: 'javascript', value: properties.listener.lScript })
              valArr.push(bpmnFactory.create('harlequin:ExecutionListener', { event: properties.listener.eType, script: theScript }))
            }

            if(properties.listener.lType == 'task') {
              if(properties.listener.sendEmails) {
                // Create script for EmailListener variables
                listTaskType = 'sendEmailsScript'
                let theScript = bpmnFactory.create('harlequin:Script', { scriptFormat: 'javascript', value: properties.listener.lScript })
                valArr.push(bpmnFactory.create('harlequin:TaskListener', { event: 'create', script: theScript }))
                this.extensionItems.push({ type: 'listener', listenerType: properties.listener.lType, listenerEventType: 'create', extId: 0, listTaskType: listTaskType })
                // Create EmailListener listener 
                listTaskType = 'sendEmails'
                valArr.push(bpmnFactory.create('harlequin:TaskListener', { event: 'create', class: 'org.rabbitsoftware.controllers.autoEmailListener.EmailListener' }))
                this.extensionItems.push({ type: 'listener', listenerType: properties.listener.lType, listenerEventType: 'create', extId: 1, listTaskType: listTaskType })
                // Add both extensions
                let listner = bpmnFactory.create('bpmn:ExtensionElements', { values: valArr })
                modeling.updateProperties(element, { extensionElements: listner })
              }else {
                let theScript = bpmnFactory.create('harlequin:Script', { scriptFormat: 'javascript', value: properties.listener.lScript })
                valArr.push(bpmnFactory.create('harlequin:TaskListener', { event: properties.listener.eType, id: properties.listener.lId, script: theScript }))
              }
            }

            // Only run if this isn't the sendEmails listener
            if(!properties.listener.sendEmails) {
              let listner = bpmnFactory.create('bpmn:ExtensionElements', { values: valArr })
              modeling.updateProperties(element, { extensionElements: listner })
              this.extensionItems.push({ type: properties.listener.propType, listenerType: properties.listener.lType, listenerEventType: properties.listener.eType, extId: 0, listTaskType: listTaskType })
            }
          }else {
            if(properties.listener.action == 'new') {
              let addListner = null
              let count = element.businessObject.extensionElements.values.length
              let listTaskType = ''
              if(properties.listener.lType == 'execution') {
                let theScript = bpmnFactory.create('harlequin:Script', { scriptFormat: 'javascript', value: properties.listener.lScript })
                addListner = bpmnFactory.create('harlequin:ExecutionListener', { event: properties.listener.eType, script: theScript })
              }

              if(properties.listener.lType == 'task') {
                if(properties.listener.sendEmails) {
                  // Create script for EmailListener variables
                  listTaskType = 'sendEmailsScript'
                  let theScript = bpmnFactory.create('harlequin:Script', { scriptFormat: 'javascript', value: properties.listener.lScript })
                  addListner = bpmnFactory.create('harlequin:TaskListener', { event: 'create', script: theScript })
                  element.businessObject.extensionElements.values.push(addListner)
                  this.extensionItems.push({ type: 'listener', listenerType: properties.listener.lType, listenerEventType: 'create', extId: count, listTaskType: listTaskType })
                  // Create EmailListener listener 
                  count++
                  listTaskType = 'sendEmails'
                  addListner = bpmnFactory.create('harlequin:TaskListener', { event: 'create', class: 'org.rabbitsoftware.controllers.autoEmailListener.EmailListener' })
                  element.businessObject.extensionElements.values.push(addListner)
                  this.extensionItems.push({ type: 'listener', listenerType: properties.listener.lType, listenerEventType: 'create', extId: count, listTaskType: listTaskType })
                }else {
                  let theScript = bpmnFactory.create('harlequin:Script', { scriptFormat: 'javascript', value: properties.listener.lScript })
                  addListner = bpmnFactory.create('harlequin:TaskListener', { event: properties.listener.eType, id: properties.listener.lId, script: theScript })
                }
              }

              // Only run if this isn't the sendEmails listener
              if(!properties.listener.sendEmails) {
                element.businessObject.extensionElements.values.push(addListner)
                this.extensionItems.push({ type: properties.listener.propType, listenerType: properties.listener.lType, listenerEventType: properties.listener.eType, extId: count, listTaskType: listTaskType })
              }
            }else if(properties.listener.action == 'update') {
              let extId;
              let itemFound;

              this.extensionItems.forEach( item => {
                if(item.listTaskType == 'sendEmailsScript') {
                  extId = item.extId;
                  itemFound = true;
                }
              })
              
              if(itemFound) {        
                element.businessObject.extensionElements.values[extId].script.value = properties.listener.lScript
              }
            }else if(properties.listener.action == 'remove') {
              let idsToRemove = [];
              let extIdsToRemove = [];
              let itemsFound = false;

              // First loop to identify the items to be removed
              this.extensionItems.forEach(item => {
                if (item.listTaskType === 'sendEmails' || item.listTaskType === 'sendEmailsScript') {
                  idsToRemove.push(item.id);
                  extIdsToRemove.push(item.extId);
                  itemsFound = true;
                }
              });

              if(itemsFound) {
                // Remove the items from extensionElements.values using extIds
                element.businessObject.extensionElements.values = element.businessObject.extensionElements.values.filter((_, index) => !extIdsToRemove.includes(index));

                // Remove the items from extensionItems using ids
                this.extensionItems = this.extensionItems.filter(item => !idsToRemove.includes(item.id));

                // Reindex after removal
                this.reindexAll();
              }
            }else {
              let extId = this.extensionItems[this.extensionItem].extId
              element.businessObject.extensionElements.values[extId].event = properties.listener.eType
              element.businessObject.extensionElements.values[extId].script.value = properties.listener.lScript

              if(properties.listener.lType == 'task') {
                element.businessObject.extensionElements.values[extId].id = properties.listener.lId
              }

              this.extensionItems[this.extensionItem] = { type: properties.listener.propType, listenerType: properties.listener.lType, listenerEventType: properties.listener.eType, extId: extId }
            }
          }
        }else if(properties.variable) {
          if(!element.businessObject.extensionElements && !this.isSignalThrowEvent) {
            let valArr = []

            if(properties.variable.inOut == 'in') {
              if(properties.variable.varType == 'all') {
                let theVar = bpmnFactory.create('harlequin:In', { variables: 'all' })
                valArr.push(theVar)
              }else {
                let theVar = bpmnFactory.create('harlequin:In', { source: properties.variable.source, target: properties.variable.target })
                valArr.push(theVar)
              }
            }

            if(properties.variable.inOut == 'out') {
              if(properties.variable.varType == 'all') {
                let theVar = bpmnFactory.create('harlequin:Out', { variables: 'all' })
                valArr.push(theVar)
              }else {
                let theVar = bpmnFactory.create('harlequin:Out', { source: properties.variable.source, target: properties.variable.target })
                valArr.push(theVar)
              }
            }

            let varbles = bpmnFactory.create('bpmn:ExtensionElements', { values: valArr })
            modeling.updateProperties(element, { extensionElements: varbles })
            this.extensionItems.push({ type: properties.variable.propType, variableInOut: properties.variable.inOut, variableType: properties.variable.varType, variableSource: properties.variable.source, variableTarget: properties.variable.target, extId: 0 })
          }else if(this.isSignalThrowEvent && !element.businessObject.eventDefinitions[0].extensionElements) {
            let valArr = []

            if(properties.variable.inOut == 'in') {
              if(properties.variable.varType == 'all') {
                let theVar = bpmnFactory.create('harlequin:In', { variables: 'all' })
                valArr.push(theVar)
              }else {
                let theVar = bpmnFactory.create('harlequin:In', { source: properties.variable.source, target: properties.variable.target })
                valArr.push(theVar)
              }
            }

            let varbles = bpmnFactory.create('bpmn:ExtensionElements', { values: valArr })
            element.businessObject.eventDefinitions[0].extensionElements = varbles
            this.extensionItems.push({ type: properties.variable.propType, variableInOut: properties.variable.inOut, variableType: properties.variable.varType, variableSource: properties.variable.source, variableTarget: properties.variable.target, sigId: 0 })
          }else {
            if(properties.variable.action == 'new') {
              if(!this.isSignalThrowEvent) {
                let varbles = null
                let count = element.businessObject.extensionElements.values.length

                if(properties.variable.inOut == 'in') {
                  if(properties.variable.varType == 'all') {
                    varbles = bpmnFactory.create('harlequin:In', { variables: 'all' })
                  }else {
                    varbles = bpmnFactory.create('harlequin:In', { source: properties.variable.source, target: properties.variable.target })
                  }
                }

                if(properties.variable.inOut == 'out') {
                  if(properties.variable.varType == 'all') {
                    varbles = bpmnFactory.create('harlequin:Out', { variables: 'all' })
                  }else {
                    varbles = bpmnFactory.create('harlequin:Out', { source: properties.variable.source, target: properties.variable.target })
                  }
                }

                element.businessObject.extensionElements.values.push(varbles)
                this.extensionItems.push({ type: properties.variable.propType, variableInOut: properties.variable.inOut, variableType: properties.variable.varType, variableSource: properties.variable.source, variableTarget: properties.variable.target, extId: count })
              }
              if(this.isSignalThrowEvent) {
                let varbles = null
                let count = element.businessObject.eventDefinitions[0].extensionElements.values.length

                if(properties.variable.inOut == 'in') {
                  if(properties.variable.varType == 'all') {
                    varbles = bpmnFactory.create('harlequin:In', { variables: 'all' })
                  }else {
                    varbles = bpmnFactory.create('harlequin:In', { source: properties.variable.source, target: properties.variable.target })
                  }
                }

                element.businessObject.eventDefinitions[0].extensionElements.values.push(varbles)
                this.extensionItems.push({ type: properties.variable.propType, variableInOut: properties.variable.inOut, variableType: properties.variable.varType, variableSource: properties.variable.source, variableTarget: properties.variable.target, sigId: count })
              }
            }else {
              if(!this.isSignalThrowEvent) {
                let extId = this.extensionItems[this.extensionItem].extId
                if(properties.variable.varType == 'all') {
                  element.businessObject.extensionElements.values[extId].variables = 'all'
                  delete element.businessObject.extensionElements.values[extId].source
                  delete element.businessObject.extensionElements.values[extId].target
                }else {
                  element.businessObject.extensionElements.values[extId].source = properties.variable.source
                  element.businessObject.extensionElements.values[extId].target = properties.variable.target
                  delete element.businessObject.extensionElements.values[extId].variables
                }

                this.extensionItems[this.extensionItem] = { type: properties.variable.propType, variableInOut: properties.variable.inOut, variableType: properties.variable.varType, variableSource: properties.variable.source, variableTarget: properties.variable.target, extId: extId }
              }
              if(this.isSignalThrowEvent) {
                let sigId = this.extensionItems[this.extensionItem].sigId
                if(properties.variable.varType == 'all') {
                  element.businessObject.eventDefinitions[0].extensionElements.values[sigId].variables = 'all'
                  delete element.businessObject.eventDefinitions[0].extensionElements.values[sigId].source
                  delete element.businessObject.eventDefinitions[0].extensionElements.values[sigId].target
                }else {
                  element.businessObject.eventDefinitions[0].extensionElements.values[sigId].source = properties.variable.source
                  element.businessObject.eventDefinitions[0].extensionElements.values[sigId].target = properties.variable.target
                  delete element.businessObject.eventDefinitions[0].extensionElements.values[sigId].variables
                }

                this.extensionItems[this.extensionItem] = { type: properties.variable.propType, variableInOut: properties.variable.inOut, variableType: properties.variable.varType, variableSource: properties.variable.source, variableTarget: properties.variable.target, sigId: sigId }
              }
            }
          }
        }else if(properties.callableElementRef) {
          modeling.updateProperties(element, { calledElement: properties.callableElementRef })
          modeling.updateProperties(element, { calledElementBinding: 'latest' })
          modeling.updateProperties(element, { caseBinding: 'latest' })

          // Remove API variables and script
          if(properties.callableElementRef != 'apiController') {
            if(typeof element.businessObject.extensionElements !== 'undefined') {
              let count = element.businessObject.extensionElements.values.length

              for(let i = 0; i < count; i++) {
                if(element.businessObject.extensionElements.values[i].variables == 'all') {
                  element.businessObject.extensionElements.values.splice(i, 1)
                  
                  for(let j = 0; j < this.extensionItems.length; j++) {
                    if(this.extensionItems[j].type == 'variable' && this.extensionItems[j].variableInOut == 'in' && this.extensionItems[j].variableType == 'all') {
                      this.extensionItems.splice(j, 1)
                    }
                  }
                  break;
                }
              }

              count = element.businessObject.extensionElements.values.length
              for(let i = 0; i < count; i++) {
                if(element.businessObject.extensionElements.values[i].source == 'apiResponse') {
                  element.businessObject.extensionElements.values.splice(i, 1)
                  
                  for(let j = 0; j < this.extensionItems.length; j++) {
                    if(this.extensionItems[j].type == 'variable' && this.extensionItems[j].variableInOut == 'out' && this.extensionItems[j].variableSource == 'apiResponse') {
                      this.extensionItems.splice(j, 1)
                    }
                  }
                  break;
                }
              }

              count = element.businessObject.extensionElements.values.length
              for(let i = 0; i < count; i++) {
                if(element.businessObject.extensionElements.values[i].source == 'apiResponseError') {
                  element.businessObject.extensionElements.values.splice(i, 1)
                  
                  for(let j = 0; j < this.extensionItems.length; j++) {
                    if(this.extensionItems[j].type == 'variable' && this.extensionItems[j].variableInOut == 'out' && this.extensionItems[j].variableSource == 'apiResponseError') {
                      this.extensionItems.splice(j, 1)
                    }
                  }
                  break;
                }
              }
            }

            this.targetApi = ''
            this.apiCallType = ''
            this.grantType = ''
            this.includeGrantType = false
            this.includeClientId = false
            this.includeClientSecret = false
            this.apiUrlQuery = ''
            this.apiPostData = '{}'
            this.addRemoveApiScript(element, bpmnFactory, 'remove')
          }else {
            if(typeof element.businessObject.extensionElements !== 'undefined') {
              let apiVars = null
              let count = element.businessObject.extensionElements.values.length
              
              for(let i = 0; i < count; i++) {
                if(element.businessObject.extensionElements.values[i].variables == 'all') {
                  element.businessObject.extensionElements.values.splice(i, 1)
                  
                  for(let j = 0; j < this.extensionItems.length; j++) {
                    if(this.extensionItems[j].type == 'variable' && this.extensionItems[j].variableInOut == 'in' && this.extensionItems[j].variableType == 'all') {
                      this.extensionItems.splice(j, 1)
                    }
                  }
                  break;
                }
              }

              count = element.businessObject.extensionElements.values.length
              for(let i = 0; i < count; i++) {
                if(element.businessObject.extensionElements.values[i].source == 'apiResponse') {
                  element.businessObject.extensionElements.values.splice(i, 1)
                  
                  for(let j = 0; j < this.extensionItems.length; j++) {
                    if(this.extensionItems[j].type == 'variable' && this.extensionItems[j].variableInOut == 'out' && this.extensionItems[j].variableSource == 'apiResponse') {
                      this.extensionItems.splice(j, 1)
                    }
                  }
                  break;
                }
              }

              count = element.businessObject.extensionElements.values.length
              for(let i = 0; i < count; i++) {
                if(element.businessObject.extensionElements.values[i].source == 'apiResponseError') {
                  element.businessObject.extensionElements.values.splice(i, 1)
                  
                  for(let j = 0; j < this.extensionItems.length; j++) {
                    if(this.extensionItems[j].type == 'variable' && this.extensionItems[j].variableInOut == 'out' && this.extensionItems[j].variableSource == 'apiResponseError') {
                      this.extensionItems.splice(j, 1)
                    }
                  }
                  break;
                }
              }

              apiVars = bpmnFactory.create('harlequin:In', { variables: 'all' })
              
              count = element.businessObject.extensionElements.values.length
              element.businessObject.extensionElements.values.push(apiVars)
              this.extensionItems.push({ type: 'variable', variableInOut: 'in', variableType: 'all', extId: count, id: count })

              count = element.businessObject.extensionElements.values.length
              apiVars = bpmnFactory.create('harlequin:Out', { source: 'apiResponse', target: 'apiResponse' })
              element.businessObject.extensionElements.values.push(apiVars)
              this.extensionItems.push({ type: 'variable', variableInOut: 'out', variableType: 'source', variableSource: 'apiResponse', variableTarget: 'apiResponse', extId: count, id: count })

              count = element.businessObject.extensionElements.values.length
              apiVars = bpmnFactory.create('harlequin:Out', { source: 'apiResponseError', target: 'apiResponseError' })
              element.businessObject.extensionElements.values.push(apiVars)
              this.extensionItems.push({ type: 'variable', variableInOut: 'out', variableType: 'source', variableSource: 'apiResponseError', variableTarget: 'apiResponseError', extId: count, id: count })
              
              this.addRemoveApiScript(element, bpmnFactory, 'remove')
              this.addRemoveApiScript(element, bpmnFactory, 'add')
            }else {
              let apiVars = null
              let apiVarArr = []

              apiVars = bpmnFactory.create('harlequin:In', { variables: 'all' })
              apiVarArr.push(apiVars)

              apiVars = bpmnFactory.create('harlequin:Out', { source: 'apiResponse', target: 'apiResponse' })
              apiVarArr.push(apiVars)

              apiVars = bpmnFactory.create('harlequin:Out', { source: 'apiResponseError', target: 'apiResponseError' })
              apiVarArr.push(apiVars)

              let varbles = bpmnFactory.create('bpmn:ExtensionElements', { values: apiVarArr })
              modeling.updateProperties(element, { extensionElements: varbles })
              this.extensionItems.push({ type: 'variable', variableInOut: 'in', variableType: 'all', extId: 0, id: 0 })
              this.extensionItems.push({ type: 'variable', variableInOut: 'out', variableType: 'source', variableSource: 'apiResponse', variableTarget: 'apiResponse', extId: 1, id: 1 })
              this.extensionItems.push({ type: 'variable', variableInOut: 'out', variableType: 'source', variableSource: 'apiResponseError', variableTarget: 'apiResponseError', extId: 2, id: 2 })
              this.addRemoveApiScript(element, bpmnFactory, 'add')
            }
          }
        }else if(properties.targetApi) {
          // API Controller Additions
          this.addRemoveApiScript(element, bpmnFactory, 'remove')
          this.addRemoveApiScript(element, bpmnFactory, 'add')
        }else if(properties.targetApiType) {
          // Call Type
          this.addRemoveApiScript(element, bpmnFactory, 'remove')
          this.addRemoveApiScript(element, bpmnFactory, 'add')
        }else if('includeGrantType' in properties) {
          // Include Grant Type
          this.addRemoveApiScript(element, bpmnFactory, 'remove')
          this.addRemoveApiScript(element, bpmnFactory, 'add')
        }else if('includeClientId' in properties) {
          // Include Client ID
          this.addRemoveApiScript(element, bpmnFactory, 'remove')
          this.addRemoveApiScript(element, bpmnFactory, 'add')
        }else if('includeClientSecret' in properties) {
          // Include Client Secret
          this.addRemoveApiScript(element, bpmnFactory, 'remove')
          this.addRemoveApiScript(element, bpmnFactory, 'add')
        }else if('apiUrlQuery' in properties) {
          // URL Query
          this.addRemoveApiScript(element, bpmnFactory, 'remove')
          this.addRemoveApiScript(element, bpmnFactory, 'add')
        }else if('apiPostData' in properties) {
          // POST Data
          this.addRemoveApiScript(element, bpmnFactory, 'remove')
          this.addRemoveApiScript(element, bpmnFactory, 'add')
        }else if('tenantId' in properties) {
          if(properties.tenantId == '') {
            delete element.businessObject.calledElementTenantId
          }else {
            modeling.updateProperties(element, { calledElementTenantId: properties.tenantId })
          }
        }else if(properties.javaClass) {
          modeling.updateProperties(element, { class: properties.javaClass })
        }else if(properties.scriptResultVariable) {
          modeling.updateProperties(element, { resultVariable: properties.scriptResultVariable })
        }else if(properties.scriptValue) {
          modeling.updateProperties(element, { script: properties.scriptValue, scriptFormat: 'javascript' })
          this.taskScript = ''
        }else if(properties.callableBusinessKey) {
          let valArr = []
          
          let bKey = bpmnFactory.create('harlequin:In', { businessKey: '#{execution.processBusinessKey}' })
          valArr.push(bKey)
          
          if(!element.businessObject.extensionElements) {
            let pCaseId = bpmnFactory.create('bpmn:ExtensionElements', { values: valArr })
            modeling.updateProperties(element, { extensionElements: pCaseId })
          }else {
            element.businessObject.extensionElements.values.push(bKey);
          }
        }else if('callableBusinessKey' in properties && !this.isProcess && !this.isCollab) {
          if(element.businessObject.extensionElements) {
            for(let i = 0; i < element.businessObject.extensionElements.values.length; i++) {
              if(element.businessObject.extensionElements.values[i].businessKey) {
                element.businessObject.extensionElements.values.splice(i, 1)
              }
            }
          }
        }else {
          if(this.isProcess) {
            const elementRegistry = modeler.get('elementRegistry')
            
            if(this.collabActive) {
              const partEl = elementRegistry._elements[this.currentParticipantId].element

              if(properties.participantId) {
                let props = []
                props['id'] = properties.participantId
                modeling.updateProperties(partEl, props)
                this.currentParticipantId = properties.participantId
              }else if(properties.participantName) {
                let props = []
                props['name'] = properties.participantName
                modeling.updateProperties(partEl, props)
              }else if(properties.id) {
                partEl.businessObject.processRef.id = properties.id
              }else if(properties.name) {
                partEl.businessObject.processRef.name = properties.name
              }else if(properties.candidateStarterUsers) {
                partEl.businessObject.processRef.candidateStarterUsers = properties.candidateStarterUsers
              }else if(properties.candidateStarterGroups) {
                partEl.businessObject.processRef.candidateStarterGroups = properties.candidateStarterGroups
              }else if(properties.historyTimeToLive) {
                partEl.businessObject.processRef.historyTimeToLive = properties.historyTimeToLive
              }else if(properties.documentation) {
                partEl.businessObject.processRef.documentation[0].text = properties.documentation.text
              }else if('isExecutable' in properties) {
                if(properties.isExecutable == null) {
                  // properties.isExecutable = false
                  properties.isExecutable = true
                }
                partEl.businessObject.processRef.isExecutable = properties.isExecutable
              }else if('isStartableInTasklist' in properties) {
                if(properties.isStartableInTasklist == null) {
                  properties.isStartableInTasklist = false
                }
                partEl.businessObject.processRef.isStartableInTasklist = properties.isStartableInTasklist
              }

              if(properties.listener) {
                if(!partEl.businessObject.processRef.extensionElements) {
                  let valArr = []

                  if(properties.listener.lType == 'execution') {
                    let theScript = bpmnFactory.create('harlequin:Script', { scriptFormat: 'javascript', value: properties.listener.lScript })
                    valArr.push(bpmnFactory.create('harlequin:ExecutionListener', { event: properties.listener.eType, script: theScript }))
                  }

                  if(properties.listener.lType == 'task') {
                    let theScript = bpmnFactory.create('harlequin:Script', { scriptFormat: 'javascript', value: properties.listener.lScript })
                    valArr.push(bpmnFactory.create('harlequin:TaskListener', { event: properties.listener.eType, id: properties.listener.lId, script: theScript }))
                  }

                  let listner = bpmnFactory.create('bpmn:ExtensionElements', { values: valArr })
                  partEl.businessObject.processRef.extensionElements = listner
                  this.extensionItems.push({ id: this.extensionItems.length, type: properties.listener.propType, listenerType: properties.listener.lType, listenerEventType: properties.listener.eType, extId: 0 })
                }else {
                  if(properties.listener.action == 'new') {
                    let addListner = null
                    let count = partEl.businessObject.processRef.extensionElements.values.length
                    if(properties.listener.lType == 'execution') {
                      let theScript = bpmnFactory.create('harlequin:Script', { scriptFormat: 'javascript', value: properties.listener.lScript })
                      addListner = bpmnFactory.create('harlequin:ExecutionListener', { event: properties.listener.eType, script: theScript })
                    }

                    if(properties.listener.lType == 'task') {
                      let theScript = bpmnFactory.create('harlequin:Script', { scriptFormat: 'javascript', value: properties.listener.lScript })
                      addListner = bpmnFactory.create('harlequin:TaskListener', { event: properties.listener.eType, id: properties.listener.lId, script: theScript })
                    }

                    partEl.businessObject.processRef.extensionElements.values.push(addListner)
                    this.extensionItems.push({ id: this.extensionItems.length, type: properties.listener.propType, listenerType: properties.listener.lType, listenerEventType: properties.listener.eType, extId: count })
                  }else {
                    let extId = this.extensionItems[this.extensionItem].extId
                    partEl.businessObject.processRef.extensionElements.values[extId].event = properties.listener.eType
                    partEl.businessObject.processRef.extensionElements.values[extId].script.value = properties.listener.lScript

                    if(properties.listener.lType == 'task') {
                      partEl.businessObject.processRef.extensionElements.values[extId].id = properties.listener.lId
                    }

                    this.extensionItems[this.extensionItem] = { type: properties.listener.propType, listenerType: properties.listener.lType, listenerEventType: properties.listener.eType, extId: extId }
                  }
                }
              }
            }else {
              const el = elementRegistry._elements[this.currentProcessId].element

              if(properties.documentation) {
                let doc = bpmnFactory.create('bpmn:Documentation')
                doc.text = properties.documentation.text
                modeling.updateProperties(el, { documentation: [doc] })
              }else if(properties.listener) {
                if(!el.businessObject.extensionElements) {
                  let valArr = []

                  if(properties.listener.lType == 'execution') {
                    let theScript = bpmnFactory.create('harlequin:Script', { scriptFormat: 'javascript', value: properties.listener.lScript })
                    valArr.push(bpmnFactory.create('harlequin:ExecutionListener', { event: properties.listener.eType, script: theScript }))
                  }

                  if(properties.listener.lType == 'task') {
                    let theScript = bpmnFactory.create('harlequin:Script', { scriptFormat: 'javascript', value: properties.listener.lScript })
                    valArr.push(bpmnFactory.create('harlequin:TaskListener', { event: properties.listener.eType, id: properties.listener.lId, script: theScript }))
                  }

                  let listner = bpmnFactory.create('bpmn:ExtensionElements', { values: valArr })
                  modeling.updateProperties(el, { extensionElements: listner })
                  this.extensionItems.push({ id: this.extensionItems.length, type: properties.listener.propType, listenerType: properties.listener.lType, listenerEventType: properties.listener.eType, extId: 0 })
                }else {
                  if(properties.listener.action == 'new') {
                    let addListner = null
                    let count = el.businessObject.extensionElements.values.length
                    if(properties.listener.lType == 'execution') {
                      let theScript = bpmnFactory.create('harlequin:Script', { scriptFormat: 'javascript', value: properties.listener.lScript })
                      addListner = bpmnFactory.create('harlequin:ExecutionListener', { event: properties.listener.eType, script: theScript })
                    }

                    if(properties.listener.lType == 'task') {
                      let theScript = bpmnFactory.create('harlequin:Script', { scriptFormat: 'javascript', value: properties.listener.lScript })
                      addListner = bpmnFactory.create('harlequin:TaskListener', { event: properties.listener.eType, id: properties.listener.lId, script: theScript })
                    }

                    el.businessObject.extensionElements.values.push(addListner)
                    this.extensionItems.push({ id: this.extensionItems.length, type: properties.listener.propType, listenerType: properties.listener.lType, listenerEventType: properties.listener.eType, extId: count })
                  }else {
                    let extId = this.extensionItems[this.extensionItem].extId
                    el.businessObject.extensionElements.values[extId].event = properties.listener.eType
                    el.businessObject.extensionElements.values[extId].script.value = properties.listener.lScript

                    if(properties.listener.lType == 'task') {
                      el.businessObject.extensionElements.values[extId].id = properties.listener.lId
                    }

                    this.extensionItems[this.extensionItem] = { type: properties.listener.propType, listenerType: properties.listener.lType, listenerEventType: properties.listener.eType, extId: extId }
                  }
                }
              }else {
                if('isExecutable' in properties) {
                  if(properties.isExecutable == null) {
                    // properties.isExecutable = false
                    properties.isExecutable = true
                  }
                }
                if('isStartableInTasklist' in properties) {
                  if(properties.isStartableInTasklist == null) {
                    properties.isStartableInTasklist = false
                  }
                }

                modeling.updateProperties(el, properties)
              }
            }
          }else if(this.isCollab) {
            if(properties.id) {
              this.collabEl.id = properties.id
            }
            if(properties.documentation) {
              let doc = bpmnFactory.create('bpmn:Documentation')
              doc.text = properties.documentation.text
              this.collabEl.documentation[0] = doc
            }
          }else {
            modeling.updateProperties(element, properties)
          }
        }
      },
      addRemoveApiScript(element, bpmnFactory, action) {
        if(action == 'add') {
          let postData = this.apiPostData.replace(/[\n\r]/g, '');

          if(this.apiCallType != 'get') {
            postData = JSON.stringify(postData)
          }else {
            postData = '{}'
            postData = JSON.stringify(postData)
          }

          let apiUrlQuery = this.apiUrlQuery.replaceAll('"', '\\"')

          if(!this.includeGrantType) {
            this.includeGrantType = false
          }
          if(!this.includeClientId) {
            this.includeClientId = false
          }
          if(!this.includeClientSecret) {
            this.includeClientSecret = false
          }

          let apiParams = this.apiParamItems
          apiParams = JSON.stringify(apiParams)
          apiParams = apiParams.replaceAll('\\', '')
          apiParams = apiParams.replaceAll('"', '\\"')

          let apiHeaders = this.apiHeaderItems
          apiHeaders = JSON.stringify(apiHeaders)
          apiHeaders = apiHeaders.replaceAll('\\', '')
          apiHeaders = apiHeaders.replaceAll('"', '\\"')
          
          let apiScript = 'execution.setVariable("requestType", "api");\n' +
              'execution.setVariable("id", ' + this.targetApi + ');\n' +
              'execution.setVariable("callType", "' + this.apiCallType + '");\n' +
              'execution.setVariable("includeGrantType", ' + this.includeGrantType + ');\n' +
              'execution.setVariable("includeClientId", ' + this.includeClientId + ');\n' +
              'execution.setVariable("includeClientSecret", ' + this.includeClientSecret + ');\n' +
              'execution.setVariable("urlQuery", "' + apiUrlQuery + '");\n' +
              'execution.setVariable("apiParams", "' + apiParams + '");\n' +
              'execution.setVariable("apiHeaders", "' + apiHeaders + '");\n' +
              'execution.setVariable("postData", ' + postData + ');'

          if(!element.businessObject.extensionElements) {
            let valArr = []

            let theScript = bpmnFactory.create('harlequin:Script', { scriptFormat: 'javascript', value: apiScript })
            valArr.push(bpmnFactory.create('harlequin:ExecutionListener', { event: 'start', script: theScript }))

            let listner = bpmnFactory.create('bpmn:ExtensionElements', { values: valArr })
            element.businessObject.extensionElements = listner
            this.extensionItems.push({ id: this.extensionItems.length, type: 'listener', listenerType: 'execution', listenerEventType: 'start', extId: 0 })
          }else {
            let addListner = null
            let count = element.businessObject.extensionElements.values.length
            
            let theScript = bpmnFactory.create('harlequin:Script', { scriptFormat: 'javascript', value: apiScript })
            addListner = bpmnFactory.create('harlequin:ExecutionListener', { event: 'start', script: theScript })
            
            element.businessObject.extensionElements.values.push(addListner)
            this.extensionItems.push({ id: this.extensionItems.length, type: 'listener', listenerType: 'execution', listenerEventType: 'start', extId: count })
          }
        }else {
          if(element.businessObject.extensionElements) {
            let count = element.businessObject.extensionElements.values.length

            for(let i = 0; i < count; i++) {
              if(element.businessObject.extensionElements.values[i].$type == 'harlequin:ExecutionListener' && element.businessObject.extensionElements.values[i].event == 'start') {
                element.businessObject.extensionElements.values.splice(i, 1)
                
                for(let j = 0; j < this.extensionItems.length; j++) {
                  if(this.extensionItems[j].type == 'listener' && this.extensionItems[j].listenerType == 'execution' && this.extensionItems[j].listenerEventType == 'start') {
                    this.extensionItems.splice(j, 1)
                  }
                }
                break;
              }
            }
          }
        }
      },
      closeProps() {
        // if(this.isFormValid) {
          this.propsDialog = false;
          // Reset values
          this.tab = 0
          this.elementId = ''
          this.elementName = ''
          this.elementNotes = ''
          this.assignee = ''
          this.candidateUsers = ''
          this.candidateGroups = ''
          this.dueDate = ''
          this.followUpDate = ''
          this.formKey = ''
          this.calledElement = ''
          this.tenantId = ''
          this.timerDefType = ''
          this.timerDefinition = ''
          this.targetApi = ''
          this.apiCallType = ''
          this.includeGrantType = false
          this.includeClientId = false
          this.includeClientSecret = false
          this.apiUrlQuery = ''
          this.apiPostData = '{}'
          this.apiParamItems = []
          this.apiHeaderItems = []
          this.sendEmails = false
          this.emailTemplate = ''
          this.emailSubject = this.$t('PROCESSES.BUILD_PROCESS.PROPERTIES.FIELDS.EMAIL_SUBJECT_DEFAULT');

          if(this.isScriptTask) {
            this.changeField(this.taskScript, 'scriptValue')
          }
        // }else {
        //   this.$refs.propsForm.validate();
        // }
      },
      openJsEditor() {
        if(this.addListenerDialog || this.editListenerDialog) {
          this.jsScript = this.listenerScript
          this.resetEditor(this.jsScript)
        }
        if(this.isScriptTask && !this.addListenerDialog && !this.editListenerDialog) {
          this.jsScript = this.taskScript
          this.resetEditor(this.jsScript)
        }

        this.jsEditorDialog = true
      },
      closeJsEditor() {
        this.jsEditorDialog = false

        if(this.addListenerDialog || this.editListenerDialog) {
          this.listenerScript = this.jsScript
        }
        if(this.isScriptTask && !this.addListenerDialog && !this.editListenerDialog) {
          this.taskScript = this.jsScript
        }

        this.resetEditor(this.defaultScript)
      },
      resetEditor(content) {
        if(this.editorState) {
          let set = this.editorState.update({changes: {from:0, to: this.editorState.doc.length, insert: content}});
          this.editorView.dispatch(set);
        }
      },
      apiParameters() {
        this.apiParamDialog = true
      },
      addParamRow() {
        this.addParamRowDialog = true
      },
      deleteParamRow(item) {
        this.apiParamItems.splice(item, 1)
        this.reorderItems('apiParamItems')
      },
      cancelParams() {
        this.apiParamDialog = false
      },
      saveParams() {
        this.apiParamDialog = false

        let { modeler, element } = this
        let bpmnFactory = modeler.get('bpmnFactory')

        this.addRemoveApiScript(element, bpmnFactory, 'remove')
        this.addRemoveApiScript(element, bpmnFactory, 'add')
      },
      cancelAddParamRow() {
        this.addParamRowDialog = false
        this.apiParamKey = ''
        this.apiParamValue = ''
        this.apiParamType = ''
        this.apiFormData = false
        this.$refs.addParamRow.resetValidation();
      },
      confirmAddParamRow() {
        this.addParamRowDialog = false
        this.apiParamItems.push({ apiParamKey: this.apiParamKey, apiParamValue: this.apiParamValue, apiParamType: this.apiParamType, apiFormData: this.apiFormData })
        this.reorderItems('apiParamItems')
        
        this.apiParamKey = ''
        this.apiParamValue = ''
        this.apiParamType = ''
        this.apiFormData = false
        this.$refs.addParamRow.resetValidation()
      },
      apiHeaders() {
        this.apiHeadersDialog = true
      },
      addHeaderRow() {
        this.addHeaderRowDialog = true
      },
      deleteHeaderRow(item) {
        this.apiHeaderItems.splice(item, 1)
        this.reorderItems('apiHeaderItems')
      },
      cancelHeaders() {
        this.apiHeadersDialog = false
      },
      saveHeaders() {
        this.apiHeadersDialog = false

        let { modeler, element } = this
        let bpmnFactory = modeler.get('bpmnFactory')

        this.addRemoveApiScript(element, bpmnFactory, 'remove')
        this.addRemoveApiScript(element, bpmnFactory, 'add')
      },
      cancelAddHeaderRow() {
        this.addHeaderRowDialog = false
        this.apiHeaderKey = ''
        this.apiHeaderValue = ''
        this.$refs.addHeaderRow.resetValidation();
      },
      confirmAddHeaderRow() {
        this.addHeaderRowDialog = false
        this.apiHeaderItems.push({ apiHeaderKey: this.apiHeaderKey, apiHeaderValue: this.apiHeaderValue })
        this.reorderItems('apiHeaderItems')
        
        this.apiHeaderKey = ''
        this.apiHeaderValue = ''
        this.$refs.addHeaderRow.resetValidation()
      },
      reorderItems(items) {
        if(items == 'apiParamItems') {
          for(let i = 0; i < this.apiParamItems.length; i++) {
            this.apiParamItems[i].id = i;
          }
        }

        if(items == 'apiHeaderItems') {
          for(let i = 0; i < this.apiHeaderItems.length; i++) {
            this.apiHeaderItems[i].id = i;
          }
        }
      },
      saveListener(action) {
        let element = this.processEl;
        this.currentProcessId = element.id

        if(action == 'new') {
          this.addListenerDialog = false;
        }

        if(action == 'edit') {
          this.editListenerDialog = false;
        }

        if(this.listenerType == 'execution') {
          this.listenerEventType = this.executionEventType
        }

        if(this.listenerType == 'task') {
          this.listenerEventType = this.taskEventType
        }

        let properties = {}
        let data = {
          propType: 'listener',
          lType: this.listenerType,
          eType: this.listenerEventType,
          lId: this.listenerId,
          lScript: this.listenerScript,
          action: action
        }
        properties['listener'] = data
        
        this.updateProperties(properties)

        if(action == 'new') {
          this.$refs.addListenerForm.reset();
        }

        if(action == 'edit') {
          this.$refs.editListenerForm.reset();
        }

        this.listenerScript = this.defaultScript
        this.reindexAll()
      },
      cancelListener(action) {
        if(action == 'new') {
          this.$refs.addListenerForm.reset();
          this.addListenerDialog = false;
        }

        if(action == 'edit') {
          this.$refs.editListenerForm.reset();
          this.editListenerDialog = false;
        }
        this.listenerScript = this.defaultScript
      },
      editListener(item) {
        const { modeler, element } = this
        let extItem = this.extensionItems[item].extId
        if(this.isProcess) {
          if(this.collabActive) {
            const el = element
            
            if(el.businessObject.processRef.extensionElements.values[extItem]['$type'].includes('Execution')) {
              this.listenerType = 'execution'
              this.executionEventType = el.businessObject.processRef.extensionElements.values[extItem].event
            }

            if(el.businessObject.processRef.extensionElements.values[extItem]['$type'].includes('Task')) {
              this.listenerType = 'task'
              this.taskEventType = el.businessObject.processRef.extensionElements.values[extItem].event
              this.listenerId = el.businessObject.processRef.extensionElements.values[extItem].id
            }

            this.listenerScript = el.businessObject.processRef.extensionElements.values[extItem].script.value
          }else {
            const elementRegistry = modeler.get('elementRegistry')
            const el = elementRegistry._elements[this.currentProcessId].element

            if(el.businessObject.extensionElements.values[extItem]['$type'].includes('Execution')) {
              this.listenerType = 'execution'
              this.executionEventType = el.businessObject.extensionElements.values[extItem].event
            }

            if(el.businessObject.extensionElements.values[extItem]['$type'].includes('Task')) {
              this.listenerType = 'task'
              this.taskEventType = el.businessObject.extensionElements.values[extItem].event
              this.listenerId = el.businessObject.extensionElements.values[extItem].id
            }

            this.listenerScript = el.businessObject.extensionElements.values[extItem].script.value
          }
        }else {
          if(element.businessObject.extensionElements.values[extItem]['$type'].includes('Execution')) {
            this.listenerType = 'execution'
            this.executionEventType = element.businessObject.extensionElements.values[extItem].event
          }

          if(element.businessObject.extensionElements.values[extItem]['$type'].includes('Task')) {
            this.listenerType = 'task'
            this.taskEventType = element.businessObject.extensionElements.values[extItem].event
            this.listenerId = element.businessObject.extensionElements.values[extItem].id
          }

          this.listenerScript = element.businessObject.extensionElements.values[extItem].script.value
        }
        
        this.extensionItem = item;
        this.editListenerDialog = true;
      },
      saveVariable(action) {
        let element = this.processEl;
        this.currentProcessId = element.id

        if(action == 'new') {
          this.addVariableDialog = false;
        }

        if(action == 'edit') {
          this.editVariableDialog = false;
        }

        if(this.variableType == 'all') {
          this.variableSource = ''
          this.variableTarget = ''
        }

        let properties = {}
        let data = {
          propType: 'variable',
          inOut: this.variableInOut,
          varType: this.variableType,
          source: this.variableSource,
          target: this.variableTarget,
          action: action
        }
        properties['variable'] = data
        this.updateProperties(properties)

        if(action == 'new') {
          this.$refs.addVariableForm.reset();
        }

        if(action == 'edit') {
          this.$refs.editVariableForm.reset();
        }

        this.reindexAll()
      },
      cancelVariable(action) {
        if(action == 'new') {
          this.$refs.addVariableForm.reset();
          this.addVariableDialog = false;
        }

        if(action == 'edit') {
          this.$refs.editVariableForm.reset();
          this.editVariableDialog = false;
        }
      },
      editVariable(item) {
        const { element } = this

        if(this.isSignalThrowEvent) {
          let sigItem = this.extensionItems[item].sigId
          if(element.businessObject.eventDefinitions[0].extensionElements.values[sigItem]['$type'].includes('In')) {
            this.variableInOut = 'in'
          }

          if(element.businessObject.eventDefinitions[0].extensionElements.values[sigItem].variables) {
            this.variableType = 'all'
          }else {
            this.variableType = 'source'
            this.variableSource = element.businessObject.eventDefinitions[0].extensionElements.values[sigItem].source
            this.variableTarget = element.businessObject.eventDefinitions[0].extensionElements.values[sigItem].target
          }
        }else {
          let extItem = this.extensionItems[item].extId
          if(element.businessObject.extensionElements.values[extItem]['$type'].includes('In')) {
            this.variableInOut = 'in'
          }else {
            this.variableInOut = 'out'
          }

          if(element.businessObject.extensionElements.values[extItem].variables) {
            this.variableType = 'all'
          }else {
            this.variableType = 'source'
            this.variableSource = element.businessObject.extensionElements.values[extItem].source
            this.variableTarget = element.businessObject.extensionElements.values[extItem].target
          }
        }
        
        this.extensionItem = item;
        this.editVariableDialog = true;
      },
      deleteExtension(item) {
        const { element } = this

        if(this.isSignalThrowEvent) {
          if(this.extensionItems[item].type == 'variable') {
            let sigItem = this.extensionItems[item].sigId
            element.businessObject.eventDefinitions[0].extensionElements.values.splice(sigItem, 1)
          }
          if(this.extensionItems[item].type == 'listener') {
            let extItem = this.extensionItems[item].extId
            element.businessObject.extensionElements.values.splice(extItem, 1)
          }
        }else {
          let extItem = this.extensionItems[item].extId
          element.businessObject.extensionElements.values.splice(extItem, 1)
        }

        this.extensionItems.splice(item, 1)

        this.reindexAll()
      },
      reindexAll() {
        let items = this.extensionItems
        this.extensionItems = []
        for(let i = 0; i < items.length; i++) {
          items[i].id = i;
          items[i].extId = i;
        }
        this.extensionItems = items
      },
      generateProcId() {
        // Set new process ID
        let chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
        this.newProcName = 'Process_';

        // Generate ID
        for (let j = 0; j < 7; j++) {
            this.newProcName += chars.charAt(Math.floor(Math.random() * chars.length));
        }
      },
      requestNewProcId() {
        this.newProcIdDialog = true;
      },
      confirmNewProcId() {
        this.newProcIdDialog = false;
        this.oldProcName = this.elementId;
        this.nameChange = true;
        this.generateProcId();
        this.changeField(this.newProcName, 'id');
        this.elementId = this.newProcName;
      },
      async newDiagram() {
        // Set new process ID
        this.generateProcId();

        let canvas = document.getElementById('canvas');
        let panel = document.getElementById('properties-panel');
        this.modeler = new Modeler({ 
          container: canvas,
          propertiesPanel: {
            parent: panel
          },
          additionalModules: [
            propertiesPanelModule,
            propertiesProviderModule
          ],
          // needed if you'd like to maintain harlequin:XXX properties in the properties panel
          moddleExtensions: {
            harlequin: harlequinModdleDescriptor
          }
        });

        try {
          await this.modeler.importXML(bpmnXML).then( () => {
            this.modeler.attachTo('#canvas');
            this.modeler.get('canvas').zoom('fit-viewport');

            // Load additional config
            this.configurePanel();
          });
        } catch (err) {
          // console.log(err);
        }
      },
      async importProcess() {
        let canvas = document.getElementById('canvas');
        let panel = document.getElementById('properties-panel');
        this.modeler = new Modeler({ 
          container: canvas,
          propertiesPanel: {
            parent: panel
          },
          additionalModules: [
            propertiesPanelModule,
            propertiesProviderModule
          ],
          // needed if you'd like to maintain harlequin:XXX properties in the properties panel
          moddleExtensions: {
            harlequin: harlequinModdleDescriptor
          }
        });

        try {
          await this.modeler.importXML(this.importXml).then( () => {
            this.modeler.attachTo('#canvas');
            this.modeler.get('canvas').zoom('fit-viewport');

            // Load additional config
            this.configurePanel();
          });
        } catch (err) {
          // console.log(err);
        }
      },
      async editDiagram(xml) {
        let canvas = document.getElementById('canvas');
        let panel = document.getElementById('properties-panel');
        this.modeler = new Modeler({ 
          container: canvas,
          propertiesPanel: {
            parent: panel
          },
          additionalModules: [
            propertiesPanelModule,
            propertiesProviderModule
          ],
          // needed if you'd like to maintain harlequin:XXX properties in the properties panel
          moddleExtensions: {
            harlequin: harlequinModdleDescriptor
          }
        });

        try {
          await this.modeler.importXML(xml).then( () => {
            this.modeler.attachTo('#canvas');
            this.modeler.get('canvas').zoom('fit-viewport');

            // Load additional config
            this.configurePanel();
          });

        } catch (err) {
          // console.log(err);
        }
      },
      async processExistsCheck() {
        let exists = false;
        for(let i =0; i < this.allProcessXml.length; i++) {
          if(this.allProcessXml[i].NAME == this.deployName) {
            exists = true;
            this.$store.commit('UPDATE_PROCESS_VERSION', this.allProcessXml[i].VERSION);
            break;
          }
        }
        if(!exists) {
          this.$store.commit('UPDATE_PROCESS_VERSION', 1);
        }
        this.processExists = exists;
      },
      async saveProcess() {
        this.deploy = false;
        this.saveTitle = this.$t('PROCESSES.SAVE_PROCESS.TITLE_SAVE');
        
        // Parse through the XML to get process name and ID
        let { xml } = await this.modeler.saveXML({ format: true });
        var parser = new DOMParser();  
        let theXml = parser.parseFromString(xml, 'text/xml');
        let theProcessData = theXml.getElementsByTagName('bpmn2:process');
        // Handle older bpmn files
        if(theProcessData.length == 0) {
          theProcessData = theXml.getElementsByTagName('bpmn:process');
        }
        this.deployName = theProcessData[0].getAttribute('id');
        
        if(this.processAction == 'new' || this.processAction == 'import' || this.processAction == 'edit') {
          if(this.deploymentName == this.deployName) {
            this.saveText = this.$t('PROCESSES.SAVE_PROCESS.SAVE');
            this.saveDialog = true;
          }else {
            this.processExistsCheck().then( () => {
              if(this.processExists) {
                this.saveText = this.$t('PROCESSES.SAVE_PROCESS.SAVE_EXISTS');
                this.saveDialog = true;
              }else {
                this.saveText = this.$t('PROCESSES.SAVE_PROCESS.SAVE');
                this.saveDialog = true;
              }
            });
          }
        }
      },
      async confirmSave() {
        this.saveDialog = false;
        let { xml } = await this.modeler.saveXML({ format: true });
        let version = this.processVersion;

        if(this.deploy) {
          version++;
        }

        // Parse through the XML to get process name and ID
        var parser = new DOMParser();  
        let theXml = parser.parseFromString(xml, 'text/xml');
        let theProcessData = theXml.getElementsByTagName('bpmn2:process');
        // Handle older bpmn files
        if(theProcessData.length == 0) {
          theProcessData = theXml.getElementsByTagName('bpmn:process');
        }
        let processName = theProcessData[0].getAttribute('name');
        let processKey = theProcessData[0].getAttribute('id');
        let selections = JSON.stringify(this.selections);
        this.theProcessName = processName;
        this.theVersion = version;
        this.theProcessKey = processKey;
        let payload = {
          'name': this.deployName,
          'processName': processName,
          'processKey': processKey,
          'xml': xml,
          'version': version,
          'selections': selections,
          'isLocked': this.isLocked,
          'lockedBy': this.lockedBy
        };
        
        this.$store.dispatch('saveProcessXml', payload).then( () => {
          if(this.processAction == 'new') {
            this.updateLog('Process', 'Created', processName, 'Process ' + processName + ' version ' + version + ' created.');
          }
          if(this.processAction == 'import') {
            this.updateLog('Process', 'Imported', processName, 'Process ' + processName + ' version ' + version + ' imported.');
          }
          if(this.processAction == 'edit') {
            this.updateLog('Process', 'Updated', processName, 'Process ' + processName + ' version ' + version + ' updated.');
          }
          if(!this.deploy) {
            this.snackSaved();
          }

          if(this.saveThenClose) {
            this.confirmClose('done');
          }

          this.$store.commit('UPDATE_PROCESS_KEY', processKey);
        });
      },
      async checkLocks() {
        let payload = {
          'checkType': 'all',
          'processKey': this.processKey,
          'processVersion': this.processVersion
        };
        await this.$store.dispatch('lockCheck', payload).then( () => {
          if(this.lockedForms.length > 0) {
            this.showLocked();
          }else {
            this.deployProcess();
          }
        });
      },
      async deployProcess() {
        this.deploy = true;
        this.saveTitle = this.$t('PROCESSES.SAVE_PROCESS.TITLE_DEPLOY');

        // Parse through the XML to get process name and ID
        let { xml } = await this.modeler.saveXML({ format: true });
        var parser = new DOMParser();  
        let theXml = parser.parseFromString(xml, 'text/xml');
        let theProcessData = theXml.getElementsByTagName('bpmn2:process');
        // Handle older bpmn files
        if(theProcessData.length == 0) {
          theProcessData = theXml.getElementsByTagName('bpmn:process');
        }
        this.deployName = theProcessData[0].getAttribute('id');

        // Set default tenant as Harlequin
        this.selectedTenant = 'harlequin';

        if(this.processAction == 'new' || this.processAction == 'import' || this.processAction == 'edit') {
          if(this.deploymentName == this.deployName) {
            this.saveText = this.$t('PROCESSES.SAVE_PROCESS.SAVE_DEPLOY');
            this.saveDialog = true;
          }else {
            this.processExistsCheck().then( () => {
              if(this.processExists) {
                this.saveText = this.$t('PROCESSES.SAVE_PROCESS.SAVE_DEPLOY_EXISTS');
                this.saveDialog = true;
              }else {
                this.saveText = this.$t('PROCESSES.SAVE_PROCESS.SAVE_DEPLOY');
                this.saveDialog = true;
              }
            });
          }
        }
      },
      async confirmDeploy() {
        this.saveDialog = false;

        let { xml } = await this.modeler.saveXML({ format: true });

        const form = new FormData();

        form.append('deployment-name', this.deployName);
        form.append('deployment-source', 'Harlequin UI');
        form.append('tenant-id', this.selectedTenant);

        const diagramName = this.deployName;

        const blob = new Blob([ xml ], { type: 'text/xml' });

        form.append(diagramName, blob, diagramName + '.bpmn');

        this.snackDeploying();

        this.$store.dispatch('deployProcess', form);
      },
      async externalProcessExistsCheck() {
        let exists = false;
        for(let i = 0; i < this.allExternalProcessXml.length; i++) {
          for(let j = 0; j < this.allExternalProcessXml[i].length; j++) {
            if(this.allExternalProcessXml[i][j].NAME == this.deployName) {
              exists = true;
              this.$store.commit('UPDATE_EXTERNAL_PROCESS_VERSION', this.allExternalProcessXml[i][j].VERSION);
              let existingData = {
                'engine': this.allExternalProcessXml[i].ENGINE,
                'version': this.allExternalProcessXml[i][j].VERSION
              };
              this.remoteExists.push(existingData);
            }
          }
        }
        if(!exists) {
          this.$store.commit('UPDATE_EXTERNAL_PROCESS_VERSION', 1);
        }
        this.processExists = exists;
      },
      cancelExternalSave() {
        this.saveExternalDialog = false;
        this.remoteExists = [];
        this.$refs.promoteForm.reset();
      },
      async saveExternalProcess() {
        this.deploy = false;
        this.saveExternalTitle = this.$t('PROCESSES.PROMOTE_PROCESS.TITLE');

        // Parse through the XML to get process name and ID
        let { xml } = await this.modeler.saveXML({ format: true });
        var parser = new DOMParser();  
        let theXml = parser.parseFromString(xml, 'text/xml');
        let theProcessData = theXml.getElementsByTagName('bpmn2:process');
        // Handle older bpmn files
        if(theProcessData.length == 0) {
          theProcessData = theXml.getElementsByTagName('bpmn:process');
        }
        this.deployName = theProcessData[0].getAttribute('id');

        await this.externalProcessExistsCheck().then( () => {
          if(this.processExists) {
            this.saveExternalText = this.$t('PROCESSES.PROMOTE_PROCESS.EXISTS');
            this.saveExternalText2 = '';
            for(let i = 0; i < this.remoteExists.length; i++) {
              this.saveExternalText2 += '<p>' + this.remoteExists[i].engine + ' @ version ' + this.remoteExists[i].version + '</p>';
            }
            this.saveExternalText2 += '<p>' + this.$t('PROCESSES.PROMOTE_PROCESS.OVERWRITE'); + '</p>';

            this.saveExternalDialog = true;
          }else {
            this.saveExternalText = this.$t('PROCESSES.PROMOTE_PROCESS.SAVE');
            this.saveExternalDialog = true;
          }
        });
      },
      async confirmExternalSave() {
        this.saveExternalDialog = false;
        let { xml } = await this.modeler.saveXML({ format: true });
        let version = this.externalProcessVersion;

        if(this.deploy) {
          version++;
        }

        // Parse through the XML to get process name and ID
        var parser = new DOMParser();  
        let theXml = parser.parseFromString(xml, 'text/xml');
        let theProcessData = theXml.getElementsByTagName('bpmn2:process');
        // Handle older bpmn files
        if(theProcessData.length == 0) {
          theProcessData = theXml.getElementsByTagName('bpmn:process');
        }
        let processName = theProcessData[0].getAttribute('name');
        let processKey = theProcessData[0].getAttribute('id');
        let selections = JSON.stringify(this.selections);
        this.theProcessName = processName;
        this.theVersion = version;
        this.theProcessKey = processKey;
        let payload = {
          'name': this.deployName,
          'processName': processName,
          'processKey': processKey,
          'xml': xml,
          'version': version,
          'selections': selections,
          'isLocked': 0,
          'lockedBy': '',
          'engine': this.selectedExternalEngine
        };
        
        this.$store.dispatch('saveExternalProcessXml', payload).then( () => {
          this.updateLog('Process', 'Promoted', processName, 'Process ' + processName + ' version ' + version + ' promoted to engine ' + this.selectedExternalEngine + '.');
          if(!this.deploy) {
            this.snackSaved();
          }
        });
      },
      redirect() {
        this.$router.push({ name: 'ProcessDesigner' });
      },
      setEncoded(name, data) {
        let encodedData = encodeURIComponent(data);
        
        if(data) {
          let e = document.createEvent('MouseEvents');
          let a = document.createElement('a');

          a.download = name;
          a.href = 'data:application/bpmn20-xml;charset=UTF-8,' + encodedData,
          e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
          a.dispatchEvent(e);
        }
      },
      async downloadSvgImage() {
        const { svg } = await this.modeler.saveSVG();
        let svgName = 'diagram.svg';

        if(this.deployName) {
          svgName = this.deployName;
        }
        this.setEncoded(svgName, svg);
      },
      async downloadDiagram() {
        const { xml } = await this.modeler.saveXML({ format: true });
        let bpmnName = this.theProcessKey;

        if(!bpmnName) {
          bpmnName = 'diagram';
        }

        if(this.deployName) {
          bpmnName = this.deployName;
        }

        bpmnName = bpmnName + '.bpmn';
        
        this.setEncoded(bpmnName, xml);
      },
      configurePanel() {
        // Palette entries
        $('.djs-palette .entry').each(function() {
            let item = $(this).attr('data-action');

            // Hide unused entries
            if(item == 'create.subprocess-expanded' || item == 'create.group') {
              $(this).hide();
            }
        });
      },
      closeProcess() {
        if(this.processAction == 'view') {
          this.confirmClose('no');
        }else {
          this.saveCloseDialog = true;
        }
      },
      confirmClose(action) {
        this.saveCloseDialog = false;
        if(action == 'save') {
          this.saveThenClose = true;
          this.saveProcess();
        }else {
          this.isLocked = 0;
          this.lockedBy = '';
          this.$store.commit('EDITING_PROCESS', false);
          let payload = {
            'checkType': 'unlock',
            'processId': 0,
            'processKey': this.theProcessKey,
          };
          this.$store.dispatch('processLockCheck', payload).then( () => {
            if(this.nameChange) {
              let payload = {
                'checkType': 'unlock',
                'processId': 0,
                'processKey': this.oldProcName,
              };
              this.$store.dispatch('processLockCheck', payload).then( () => {
                this.$router.push({ name: 'ProcessDesigner' });
              });
            }else {
              this.$router.push({ name: 'ProcessDesigner' });
            }
          });
        }
      },
      showLocked() {
        this.lockedTitle = this.$t('PROCESSES.PROCESS_LOCKED.TITLE');
        this.lockedText = this.$t('PROCESSES.PROCESS_LOCKED.LOCKED_FORMS');
        this.lockedFormText = '';

        for(let i = 0; i < this.lockedForms.length; i++) {
          this.lockedFormText += '<b>' + this.lockedForms[i].FORM_TITLE + '</b> ' + this.$t('PROCESSES.PROCESS_LOCKED.LOCKED_FORMS_TEXT') + ' <b>' + this.lockedForms[i].LOCKED_BY + '</b>.<br>';
        }

        this.showLockedDialog = true;
      },
      snackSaved () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Process saved successfully.'
      },
      snackFail () {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = 'Deployment failed: invalid XML.'
      },
      snackExists () {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = 'The deployment ID already exists. Please enter a different ID.'
      },
      snackDeploying () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Deploying the process, please wait...'
      },
      snackRedirect() {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Redirecting, please wait...'
      },
      updateLog(cat, op, process, msg) {
        let dt = new Date();
        let dateTime = new Intl.DateTimeFormat('en-GB', 
          {
            day: 'numeric',
            month: 'numeric', 
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: false
          }).format(dt);

        let logData = {
          'category': cat,
          'userId': this.$store.state.currentUser,
          'caseId': 0,
          'processName': process,
          'taskName': null,
          'operation': op,
          'msg': msg,
          'dateTime': dateTime,
        };
        this.$store.dispatch('updateOpLog', logData);
      }
    }
  }
</script>

<style>
  .canvas, .bjs-container,
  .djs-container, .djs-container > svg {
    height: calc(100vh - 155px);
  }
  .properties-panel-parent {
    border-top: 1px solid #ccc;
    border-left: 1px solid #ccc;
    height: calc(100vh - 155px);
    overflow: auto;
  }
  .properties-panel-parent > .djs-properties-panel {
    padding-bottom: 70px;
    min-height:100%;
  }
  .djs-container {
    --palette-background-color: #1b1b1b !important;
    --palette-border-color: #000 !important;
    --palette-entry-hover-color: #fff !important;
    --palette-entry-color: #f87723 !important;
    --palette-entry-selected-color: #000 !important;
  }
  .djs-visual > rect {
    stroke: #f87723 !important;
  }
  .bpp-field-wrapper > textarea {
    font-size: 20px !important;
  }
  .djs-overlay-context-pad {
    width: 22px !important;
  }
  .djs-context-pad {
    padding: 5px !important;
  }
  .djs-context-pad.open,
  .djs-popup {
    background-color: black !important;
  }
  .djs-context-pad.open .entry,
  .djs-popup .entry {
    background-color: black !important;
    box-shadow: none !important;
    color: #f87723 !important;
  }
  .djs-context-pad.open .entry:hover,
  .djs-popup .entry:hover {
    background: none !important;
    color: white !important;
  }
  .djs-popup .entry.entry.bpmn-icon-default-flow:hover,
  .djs-popup .entry.entry.bpmn-icon-connection:hover {
    background-color: black !important;
    color: white !important;
  }
  [data-container-id*="StartEvent_"] .entry.bpmn-icon-screw-wrench,
  [data-container-id*="Event_"] .entry.bpmn-icon-screw-wrench,
  [data-container-id*="Gateway_"] .entry.bpmn-icon-screw-wrench,
  [data-container-id*="DataStoreReference_"] .entry.bpmn-icon-screw-wrench,
  [data-container-id*="DataObjectReference_"] .entry.bpmn-icon-screw-wrench {
    display: none !important;
  }
  .djs-popup-body .entry.bpmn-icon-task,
  .djs-popup-body .entry.bpmn-icon-send,
  .djs-popup-body .entry.bpmn-icon-receive,
  .djs-popup-body .entry.bpmn-icon-user,
  .djs-popup-body .entry.bpmn-icon-manual,
  .djs-popup-body .entry.bpmn-icon-business-rule,
  .djs-popup-body .entry.bpmn-icon-service,
  .djs-popup-body .entry.bpmn-icon-script,
  .djs-popup-body .entry.bpmn-icon-call-activity,
  .djs-popup-body .entry.bpmn-icon-subprocess-collapsed,
  .djs-popup-body .entry.bpmn-icon-subprocess-expanded,
  .djs-popup-body .entry.bpmn-icon-conditional-flow,
  .entry.bpmn-icon-loop-marker {
    display: none !important;
  }
  .processBtn {
    position: absolute;
    bottom: 40%;
    right: 12px;
  }
  .modeBtn {
    position: absolute;
    bottom: 34%;
    right: 12px;
  }
</style>